import { APP_CONSTANTS } from 'src/app/constants/constants';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';

import * as ApexCharts from 'apexcharts';

declare var require: any;
var Highcharts = require('highcharts/highmaps.js');
var USA = require('@highcharts/map-collection/countries/us/us-all.geo.json');


import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { ActivitiesComponent } from '../../activities/activities.component';

@Component({
	selector: 'app-stage-process-view',
	templateUrl: './stage-process-view.component.html',
	styleUrls: ['./stage-process-view.component.scss']
})
export class StageProcessViewComponent implements OnInit {
  APP_CONSTANTS = APP_CONSTANTS;

	@Input() selected_tab: any;
	@Input() stepper_stage: any;
	@Input() type: any;
	@Input() business_plan: any;
	@Input() selected_opportunity_period: any;
	@Output() stateChanged = new EventEmitter<any>();

	graphSlideConfig = { slidesToShow: 2, slidesToScroll: 1, infinite: false, arrows: true, };
	user_details: any;
	user_role: any = "";

	analysis_type: any = "";

	constructor(
		public commonService: CommonService,
		private storageService: StorageService,
		private dialog: MatDialog,
	) {}

	ngOnInit(): void {
		this.user_details = this.storageService.get("user_details");

		if (this.user_details.role.role == 4) {
			this.user_role = "Advisor Manager";
		} else if (this.user_details.role.role == 5) {
			this.user_role = "Advisor";
		} else if (this.user_details.role.role == 6) {
			this.user_role = "AFA";
		} else if (this.user_details.role.role == 7) {
			this.user_role = "Assistant";
		} else if (this.user_details.role.role == 8) {
			this.user_role = "Relationship Manager";
		} else if (this.user_details.role.role == 11) {
			this.user_role = "Marketing Team";
		}

		if (this.type == "Upside Opportunities") {
			this.ai_explainability_sections = this.upside_opportunity_ai_explainability_sections;
			this.analysis_type = "Opportunity";
		} else if (this.type == "Retention Opportunities") {
			this.ai_explainability_sections = this.retention_opportunity_ai_explainability_sections;
			this.analysis_type = "Retention";
		// } else if (this.type == "Institutional Customers to Investment Clients") {
		} else if (this.type == "Bank Customers to Investment Clients") {
			this.ai_explainability_sections = this.leads_ai_explainability_sections;
			this.analysis_type = "New";
		// } else if (this.type == "Institutional Customers to Deposit Clients") {
		} else if (this.type == "New Prospects") {
			this.ai_explainability_sections = this.leads_ai_explainability_sections;
			this.analysis_type = "New Prospect";
		} else if (this.type == "Bank Customers to Deposit Clients") {
			this.ai_explainability_sections = this.deposit_ai_explainability_sections;
			this.analysis_type = "members";
		} else if (this.type == "Bank Customers to Lending Clients") {
			this.ai_explainability_sections = this.lending_ai_explainability_sections;
			this.analysis_type = "members";
		} else if (this.type == "Bank Customers to Insurance Clients") {
			this.ai_explainability_sections = this.insurance_ai_explainability_sections;
			this.analysis_type = "members";
		} else if (this.type == "Non Customers") {
			this.ai_explainability_sections = this.non_customer_ai_explainability_sections;
			this.analysis_type = "non_members";
		} else if (this.type == "Upside Opportunities MAGI") {
			this.ai_explainability_sections = this.upside_opportunity_ai_explainability_sections;
			this.analysis_type = "Opportunity MAGI";
		} else if (this.type == "Retention Opportunities MAGI") {
			this.ai_explainability_sections = this.retention_opportunity_ai_explainability_sections;
			this.analysis_type = "Retention MAGI";
		} else if (this.type == "Bank Customers to Investment Clients MAGI") {
			this.ai_explainability_sections = this.leads_ai_explainability_sections;
			this.analysis_type = "New MAGI";
		} else if (this.type == "New Prospects MAGI") {
			this.ai_explainability_sections = this.leads_ai_explainability_sections;
			this.analysis_type = "New Prospect MAGI";
		} else if (this.type == "Bank Customers to Deposit Clients MAGI") {
			this.ai_explainability_sections = this.deposit_ai_explainability_sections;
			this.analysis_type = "members_agi";
		} else if (this.type == "Non Customers MAGI") {
			this.ai_explainability_sections = this.non_customer_ai_explainability_sections;
			this.analysis_type = "non_members_agi";
		} else if (this.type == "Advisor Manager Bank Customers to Investment Clients MAGI") {
			this.ai_explainability_sections = this.leads_ai_explainability_sections;
			this.analysis_type = "New MAGI";
		} else if (this.type == "Advisor Manager New Prospects MAGI") {
			this.ai_explainability_sections = this.leads_ai_explainability_sections;
			this.analysis_type = "New Prospect MAGI";
		} else if (this.type == "Advisor Manager Bank Customers to Deposit Clients MAGI") {
			this.ai_explainability_sections = this.deposit_ai_explainability_sections;
			this.analysis_type = "members_agi";
		} else if (this.type == "Advisor Manager Non Customers MAGI") {
			this.ai_explainability_sections = this.non_customer_ai_explainability_sections;
			this.analysis_type = "non_members_agi";
		} else if (this.type == "Marketing Team Bank Customers to Investment Clients Unassigned") {
			this.ai_explainability_sections = this.leads_ai_explainability_sections;
			this.analysis_type = "New MAGI";
		} else if (this.type == "Marketing Team New Prospects Unassigned") {
			this.ai_explainability_sections = this.leads_ai_explainability_sections;
			this.analysis_type = "New Prospect MAGI";
		} else if (this.type == "Marketing Team New Prospects - Investments Unassigned") {
			this.ai_explainability_sections = this.leads_ai_explainability_sections;
			this.analysis_type = "New Prospect MAGI";
		} else if (this.type == "Marketing Team Bank Customers to Deposit Clients Unassigned") {
			this.ai_explainability_sections = this.deposit_ai_explainability_sections;
			this.analysis_type = "members_agi";
		} else if (this.type == "Marketing Team Non Customers Unassigned") {
			this.ai_explainability_sections = this.non_customer_ai_explainability_sections;
			this.analysis_type = "non_members_agi";
		} else if (this.type == "Marketing Team New Prospects - Deposits Unassigned") {
			this.ai_explainability_sections = this.non_customer_ai_explainability_sections;
			this.analysis_type = "non_members_agi";
		} else if (this.type == "Marketing Team Bank Customers to Lending Clients Unassigned") {
			this.ai_explainability_sections = this.lending_ai_explainability_sections;
			this.analysis_type = "lending_agi";
		} else if (this.type == "Marketing Team New Prospects - Lending Unassigned") {
			this.ai_explainability_sections = this.lending_ai_explainability_sections;
			this.analysis_type = "non_members_agi";
		} else if (this.type == "Marketing Team Bank Customers to Insurance Clients Unassigned") {
			this.ai_explainability_sections = this.insurance_ai_explainability_sections;
			this.analysis_type = "insurance_agi";
		} else if (this.type == "Marketing Team New Prospects - Insurance Unassigned") {
			this.ai_explainability_sections = this.insurance_ai_explainability_sections;
			this.analysis_type = "non_members_agi";
		} else if (this.type == "Marketing Team Bank Customers to Investment Clients Assigned") {
			this.ai_explainability_sections = this.leads_ai_explainability_sections;
			this.analysis_type = "New";
		} else if (this.type == "Marketing Team New Prospects Assigned") {
			this.ai_explainability_sections = this.leads_ai_explainability_sections;
			this.analysis_type = "New Prospect";
		} else if (this.type == "Marketing Team New Prospects - Investments Assigned") {
			this.ai_explainability_sections = this.leads_ai_explainability_sections;
			this.analysis_type = "New Prospect";
		} else if (this.type == "Marketing Team Bank Customers to Deposit Clients Assigned") {
			this.ai_explainability_sections = this.deposit_ai_explainability_sections;
			this.analysis_type = "members";
		} else if (this.type == "Marketing Team Non Customers Assigned") {
			this.ai_explainability_sections = this.non_customer_ai_explainability_sections;
			this.analysis_type = "non_members";
		} else if (this.type == "Marketing Team New Prospects - Deposits Assigned") {
			this.ai_explainability_sections = this.non_customer_ai_explainability_sections;
			this.analysis_type = "non_members";
		} else if (this.type == "Marketing Team Bank Customers to Lending Clients Assigned") {
			this.ai_explainability_sections = this.lending_ai_explainability_sections;
			this.analysis_type = "lending";
		} else if (this.type == "Marketing Team New Prospects - Lending Assigned") {
			this.ai_explainability_sections = this.non_customer_ai_explainability_sections;
			this.analysis_type = "non_members";
		} else if (this.type == "Marketing Team Bank Customers to Insurance Clients Assigned") {
			this.ai_explainability_sections = this.insurance_ai_explainability_sections;
			this.analysis_type = "insurance";
		} else if (this.type == "Marketing Team New Prospects - Insurance Assigned") {
			this.ai_explainability_sections = this.non_customer_ai_explainability_sections;
			this.analysis_type = "non_members";
		}

		this.getPageSummary();
		this.getStages();

		this.getConversionStatusList();
		this.getProductList();
		this.getClientProductStatus();
		this.getAttritionReasons();
		this.getObjectives();
		this.getProducts();


		if (this.user_details.role.role == 11) {
			this.getAdvisors();
			this.getAdvisorTeams();
		}
	}

	page_summary_data: any;
	page_summary_data_loaded: boolean = false;
	getPageSummary() {
		this.page_summary_data_loaded = false;
		let route: any = "";
		if ((this.selected_tab == "MAGI") && (this.user_details.role.role == 8 || this.user_details.role.role == 13 || this.user_details.role.role == 14)) {
      if (this.type == "Upside Opportunities") {
        if (this.stepper_stage.position == "last") {
          route = "/magiclientresults/chartsupdated/" + "?duration=" + this.selected_opportunity_period + "&opportunity_type=" + this.type;
        } else {
          route = "/magiclient_charts/" + "?duration=" + this.selected_opportunity_period + "&opportunity_type=" + this.type;
        }
      } else if (this.type == "Retention Opportunities") {
        if (this.stepper_stage.position == "last") {
          route = route = "/magiclientresults/chartsupdated/" + "?duration=" + this.selected_opportunity_period + "&opportunity_type=" + this.type;
        } else {
          route = "/magiclient_charts/" + "?duration=" + this.selected_opportunity_period + "&opportunity_type=" + this.type;
        }
      } else if (this.type == "Bank Customers to Investment Clients") {
        if (this.stepper_stage.position == "last") {
          route = route = "/magiclientresults/chartsupdated/" + "?duration=" + this.selected_opportunity_period + "&opportunity_type=" + this.type + "&business_plan_id=" + this.business_plan;
        } else {
          route = "/magiclient_charts/" + "?duration=" + this.selected_opportunity_period + "&opportunity_type=" + this.type + "&business_plan_id=" + this.business_plan;
        }
        route = route + "&prospect_type=New";
      } else if (this.type == "New Prospects" && this.user_details.role.business_area[0] == 5) {
         if (this.stepper_stage.position == "last") {
          route = route = "/magiclientresults/chartsupdated/" + "?duration=" + this.selected_opportunity_period + "&opportunity_type=" + this.type + "&business_plan_id=" + this.business_plan;
        } else {
          route = "/magiclient_charts/" + "?duration=" + this.selected_opportunity_period + "&opportunity_type=" + this.type + "&business_plan_id=" + this.business_plan;
        }
        route = route + "&prospect_type=New Prospect";
      } else if (this.type == "New Prospects" && this.user_details.role.business_area[0] != 5) {
         if (this.stepper_stage.position == "last") {
          route = "/magiprospectresults/chartsupdated?&business_plan_id=" + this.business_plan;
        } else {
          route = "/magiprospect_charts/?&order=" + this.stepper_stage.order + "&business_plan_id=" + this.business_plan;
        }

        route = route + "&prospect_type=non_members_magi";
      } else if (this.type == "Bank Customers to Deposit Clients") {
        if (this.stepper_stage.position == "last") {
          route = "/magiprospectresults/chartsupdated?&business_plan_id=" + this.business_plan;
        } else {
          route = "/magiprospect_charts/?&order=" + this.stepper_stage.order + "&business_plan_id=" + this.business_plan;
        }

        route = route + "&prospect_type=members_magi";

      } else if (this.type == "Bank Customers to Lending Clients") {
        if (this.stepper_stage.position == "last") {
          route = "/magiprospectresults/chartsupdated?business_plan_id=" + this.business_plan;
        } else {
          route = "/magiprospect_charts/?order=" + this.stepper_stage.order + "&business_plan_id=" + this.business_plan;
        }

        route = route + "&prospect_type=lending_magi";

      } else if (this.type == "Bank Customers to Insurance Clients") {
        if (this.stepper_stage.position == "last") {
          route = "/magiprospectresults/chartsupdated?business_plan_id=" + this.business_plan;
        } else {
          route = "/magiprospect_charts/?order=" + this.stepper_stage.order + "&business_plan_id=" + this.business_plan;
        }

        route = route + "&prospect_type=insurance_magi";

      } else if (this.type == "Non Customers") {
        if (this.stepper_stage.position == "last") {
          route = "/magiprospectresults/chartsupdated?stage_id=" + this.stepper_stage.id + "&business_plan_id=" + this.business_plan;
        } else {
          route = "/magiprospect_charts/?stage_id=" + this.stepper_stage.id + "&order=" + this.stepper_stage.order + "&business_plan_id=" + this.business_plan;
        }

        route = route + "&prospect_type=non_members_magi";

      }
    } else {
      if (this.type == "Upside Opportunities") {
        if (this.stepper_stage.position == "last") {
          route = "/results/chartsupdated?stage_id=" + this.stepper_stage.id;
        } else {
          route = "/clientsalesprocess/chartsupdated?stage_id=" + this.stepper_stage.id + "&order=" + this.stepper_stage.order;
        }
      } else if (this.type == "Retention Opportunities") {
        if (this.stepper_stage.position == "last") {
          route = "/attritionoptimizeupdated/" + this.stepper_stage.id + "/" + "?opp_year=" + this.selected_opportunity_period;
        } else {
          route = "/clientattritionsalesprocessupdated/?stage_id=" + this.stepper_stage.id + "&order=" + this.stepper_stage.order;
        }
      // } else if (this.type == "Institutional Customers to Investment Clients") {
      } else if (this.type == "Bank Customers to Investment Clients") {
        if (this.stepper_stage.position == "last") {
          route = "/prospectresults/chartsupdated?stage_id=" + this.stepper_stage.id + "&business_plan_id=" + this.business_plan;
        } else {
          route = "/prospect_charts/?stage_id=" + this.stepper_stage.id + "&order=" + this.stepper_stage.order + "&business_plan_id=" + this.business_plan;
        }
        route = route + "&prospect_type=New";
      } else if (this.type == "New Prospects") {
        if (this.stepper_stage.position == "last") {
          route = "/prospectresults/chartsupdated?stage_id=" + this.stepper_stage.id + "&business_plan_id=" + this.business_plan;
        } else {
          route = "/prospect_charts/?stage_id=" + this.stepper_stage.id + "&order=" + this.stepper_stage.order + "&business_plan_id=" + this.business_plan;
        }
        route = route + "&prospect_type=New Prospect";
      // } else if (this.type == "Institutional Customers to Deposit Clients") {
      } else if (this.type == "Bank Customers to Deposit Clients") {
        if (this.stepper_stage.position == "last") {
          route = "/prospectresults/chartsupdated?stage_id=" + this.stepper_stage.id + "&business_plan_id=" + this.business_plan;
        } else {
          route = "/prospect_charts/?stage_id=" + this.stepper_stage.id + "&order=" + this.stepper_stage.order + "&business_plan_id=" + this.business_plan;
        }

        route = route + "&prospect_type=members";

      } else if (this.type == "Non Customers") {
        if (this.stepper_stage.position == "last") {
          route = "/prospectresults/chartsupdated?stage_id=" + this.stepper_stage.id + "&business_plan_id=" + this.business_plan;
        } else {
          route = "/prospect_charts/?stage_id=" + this.stepper_stage.id + "&order=" + this.stepper_stage.order + "&business_plan_id=" + this.business_plan;
        }

        route = route + "&prospect_type=non_members";

      } else if (this.type == "Upside Opportunities MAGI") {
        route = "/agitabcharts/?advisor_id=" + this.user_details.id + "&type=opportunity"
      } else if (this.type == "Retention Opportunities MAGI") {
        route = "/agitabcharts/?advisor_id=" + this.user_details.id + "&type=retention"
      } else if (this.type == "Bank Customers to Investment Clients MAGI") {
        route = "/agitabcharts/?advisor_id=" + this.user_details.id + "&type=new"
      } else if (this.type == "New Prospects MAGI") {
        route = "/agitabcharts/?advisor_id=" + this.user_details.id + "&type=new_prospect"
      } else if (this.type == "Bank Customers to Deposit Clients MAGI") {
        route = "/agitabcharts/?advisor_id=" + this.user_details.id + "&type=members"
      } else if (this.type == "Non Customers MAGI") {
        route = "/agitabcharts/?advisor_id=" + this.user_details.id + "&type=non_members"
      } else if (this.type == "Advisor Manager Bank Customers to Investment Clients MAGI") {
        route = "/amagitabcharts/?advisor_manager_id=" + this.user_details.id + "&type=new"
      } else if (this.type == "Advisor Manager New Prospects MAGI") {
        route = "/amagitabcharts/?advisor_manager_id=" + this.user_details.id + "&type=new_prospect"
      } else if (this.type == "Advisor Manager Bank Customers to Deposit Clients MAGI") {
        route = "/amagitabcharts/?advisor_manager_id=" + this.user_details.id + "&type=members"
      } else if (this.type == "Advisor Manager Non Customers MAGI") {
        route = "/amagitabcharts/?advisor_manager_id=" + this.user_details.id + "&type=non_members"
      } else if (this.type == "Marketing Team Bank Customers to Investment Clients Unassigned") {
        route = "/unassignedagitabcharts/?advisor_id=" + this.user_details.id + "&type=new"
      } else if (this.type == "Marketing Team New Prospects Unassigned") {
        route = "/unassignedagitabcharts/?advisor_id=" + this.user_details.id + "&type=new_prospect"
      } else if (this.type == "Marketing Team New Prospects - Investments Unassigned") {
        route = "/unassignedagitabcharts/?advisor_id=" + this.user_details.id + "&type=new_prospect"
      } else if (this.type == "Marketing Team Bank Customers to Deposit Clients Unassigned") {
        route = "/unassignedagitabcharts/?advisor_id=" + this.user_details.id + "&type=members"
      } else if (this.type == "Marketing Team Non Customers Unassigned") {
        route = "/unassignedagitabcharts/?advisor_id=" + this.user_details.id + "&type=non_members"
      } else if (this.type == "Marketing Team New Prospects - Deposits Unassigned") {
        route = "/unassignedagitabcharts/?advisor_id=" + this.user_details.id + "&type=non_members"
      } else if (this.type == "Marketing Team Bank Customers to Lending Clients Unassigned") {
        route = "/unassignedagitabcharts/?advisor_id=" + this.user_details.id + "&type=members"
      } else if (this.type == "Marketing Team New Prospects - Lending Unassigned") {
        route = "/unassignedagitabcharts/?advisor_id=" + this.user_details.id + "&type=non_members"
      } else if (this.type == "Marketing Team Bank Customers to Insurance Clients Unassigned") {
        route = "/unassignedagitabcharts/?advisor_id=" + this.user_details.id + "&type=members"
      } else if (this.type == "Marketing Team New Prospects - Insurance Unassigned") {
        route = "/unassignedagitabcharts/?advisor_id=" + this.user_details.id + "&type=non_members"
      } else if (this.type == "Marketing Team Bank Customers to Investment Clients Assigned") {
        route = "/assignedagitabcharts/?advisor_id=" + this.user_details.id + "&type=new"
      } else if (this.type == "Marketing Team New Prospects Assigned") {
        route = "/assignedagitabcharts/?advisor_id=" + this.user_details.id + "&type=new_prospect"
      } else if (this.type == "Marketing Team New Prospects - Investments Assigned") {
        route = "/assignedagitabcharts/?advisor_id=" + this.user_details.id + "&type=new_prospect"
      } else if (this.type == "Marketing Team Bank Customers to Deposit Clients Assigned") {
        route = "/assignedagitabcharts/?advisor_id=" + this.user_details.id + "&type=members"
      } else if (this.type == "Marketing Team Non Customers Assigned") {
        route = "/assignedagitabcharts/?advisor_id=" + this.user_details.id + "&type=non_members"
      } else if (this.type == "Marketing Team New Prospects - Deposits Assigned") {
        route = "/assignedagitabcharts/?advisor_id=" + this.user_details.id + "&type=non_members"
      } else if (this.type == "Marketing Team Bank Customers to Lending Clients Unassigned") {
        route = "/unassignedagitabcharts/?advisor_id=" + this.user_details.id + "&type=lending"
      } else if (this.type == "Marketing Team Bank Customers to Lending Clients Assigned") {
        route = "/assignedagitabcharts/?advisor_id=" + this.user_details.id + "&type=lending"
      } else if (this.type == "Marketing Team New Prospects - Lending Assigned") {
        route = "/assignedagitabcharts/?advisor_id=" + this.user_details.id + "&type=non_members"
      } else if (this.type == "Marketing Team Bank Customers to Insurance Clients Unassigned") {
        route = "/unassignedagitabcharts/?advisor_id=" + this.user_details.id + "&type=insurance"
      } else if (this.type == "Marketing Team Bank Customers to Insurance Clients Assigned") {
        route = "/assignedagitabcharts/?advisor_id=" + this.user_details.id + "&type=insurance"
      } else if (this.type == "Marketing Team New Prospects - Insurance Assigned") {
        route = "/assignedagitabcharts/?advisor_id=" + this.user_details.id + "&type=non_members"
      }
    }

		route = route + "&opp_year=" + this.selected_opportunity_period;

		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.page_summary_data = res["data"];

				if (this.show_graphical_representation == true) {

					setTimeout(() => {
						for (let index = 0; index < this.page_summary_data["graphs_list"].length; index++) {
							this.initiateGraph(this.page_summary_data["graphs_list"][index].type, index)
						}
					}, 200);
				}

				this.getTableData();

				this.page_summary_data_loaded = true;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);

	}

	advisor_list: any = [];
	getAdvisors() {
		this.commonService.getData("/mtadvisorslist/").subscribe(
			(res: any) => {
				this.advisor_list = res["data"];
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	show_graphical_representation: boolean = false;
	toggleGraphs() {
		if (this.show_graphical_representation == true) {
			this.getPageSummary();
		}
	}



	initiateGraph(type, index) {
		setTimeout(() => {
			if (type == "bar") {
				this.createBarGraph(index);
			} else if (type == "map") {
				// this.createRegionGraph(index);
			} else if (type == "tree") {
				this.createTreeMapGraph(index);
			} else if (type == "pie") {
				this.createPieGraph(index);
			} else if (type == "stacked_bar") {
				this.createStackedBarGraph(index);
			} else if (type == "radar_chart") {
				this.createRadarGraph(index);
			} else if (type == "donut") {
				this.createDonutGraph(index);
			}
		}, 200);
	}

	disable_future_client_data_selection: boolean = false;
	createBarGraph(index) {
		let $this = this;
		var options = {
			colors:  $this.page_summary_data['graphs_list'][index]['data']['colors'],
			series: [
				{
					name: '',
					data: $this.page_summary_data['graphs_list'][index]['data']['y-axis'],
				},
			],
			chart: {
				type: $this.page_summary_data['graphs_list'][index]['type'],
				events: {
					dataPointSelection: function (event, chartContext, config) {
						const details = {
							id: $this.page_summary_data['graphs_list'][index]['data']['click_filter'][config.dataPointIndex],
							name: $this.page_summary_data['graphs_list'][index]['data']['x-axis'][config.dataPointIndex],
						};
						const filter_id = $this.page_summary_data['graphs_list'][index].filter_key;
						const filter_name = $this.page_summary_data['graphs_list'][index].filter_key_name;

						if (($this.page_summary_data['graphs_list'][index].filter_key == "yearly_filter") && (parseInt(details.id) < (new Date().getFullYear() + 1)))  {
							$this.disable_future_client_data_selection = false;
						} else {
							$this.disable_future_client_data_selection = true;
						}

						$this.page_summary_data['graphs_list'][index][filter_id] = $this.page_summary_data['graphs_list'][index][filter_id] == details.id ? '' : details.id;

						$this.page_summary_data['graphs_list'][index][filter_name] = $this.page_summary_data['graphs_list'][index][filter_name] == details.name ? '' : details.name;

						$this.current_pagination_page = 1;

						$this.getTableData();
					},
				},
				toolbar: {
				show: false,
				},
				zoom: {
				enabled: false,
				},
				height: 280,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			plotOptions: {
				bar: {
					horizontal: false,
					columnWidth: $this.commonService.getBarGraphPercentWidth(
						document.getElementById( $this.page_summary_data['graphs_list'][index]['id']).clientWidth,
						$this.page_summary_data['graphs_list'][index]['data']['x-axis'].length,
						20,
					),
					endingShape: 'rounded',
					// dataLabels: {
					//   position: 'bottom'
					// },
				},
			},
			dataLabels: {
				enabled: false,
				textAnchor: 'start',
				style: {
					colors: ['#000000'],
					fontWeight: '200',
				},
				formatter: function (val, opt) {
					return opt.w.globals.labels[opt.dataPointIndex];
				},
				offsetX: 0,
				dropShadow: {
					enabled: false,
				},
			},
			stroke: {
				show: true,
				width: 0,
				colors: ['transparent'],
			},
			xaxis: {
				categories: $this.page_summary_data['graphs_list'][index]['data']['x-axis'],
				title: {
					// text: 'Age Range'
				},
				crosshairs: {
					show: false,
				},
			},
			yaxis: {
				labels: {
					show: false,
				},
			},
			fill: {
				opacity: 1,
			},
			tooltip: {
				// y: {
				//   formatter: function (val) {
				//     return val
				//   }
				// }
				custom: function ({ series, seriesIndex, dataPointIndex, w }) {
					if ($this.page_summary_data['graphs_list'][index]['data']['legends']) {
						return (
							'<div style="width:250px; padding:8px">' +
							// '<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Age</b>: ' +
							// $this.page_summary_data['graphs_list'][index]['data']['x-axis'][dataPointIndex] +
							// '</p>' +
							'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Name</b>: ' +
							$this.page_summary_data['graphs_list'][index]['data']['legends'][dataPointIndex] +
							'</p>' +
							'<p><b>Value</b>: ' +
							$this.page_summary_data['graphs_list'][index]['data']['y-axis'][dataPointIndex] +
							'</p>' +
							'<p style="width:100%;text-overflow:clip;white-space:break-spaces"><b>Description</b>: ' +
							$this.page_summary_data['graphs_list'][index]['data']['description'][dataPointIndex] +
							'</p>' +
							'</div>'
						);
					} else {
						return (
							$this.page_summary_data['graphs_list'][index]['data']['x-axis'][dataPointIndex] + ":" + $this.page_summary_data['graphs_list'][index]['data']['y-axis'][dataPointIndex]
						);
					}

				},
				// fixed: {
				// 	enabled: true,
				// 	position: "topRight"
				// }
			},
		};
		var chart = new ApexCharts(document.querySelector('#' + this.page_summary_data['graphs_list'][index].id), options);
		chart.render();
	}

	updateFlag = false;
	Highcharts: typeof Highcharts = Highcharts;
	chartConstructor = 'mapChart';
	chartOptions: Highcharts.Options = {
		chart: {
			map: USA,
		},
		exporting: {
			enabled: false,
		},
		title: {
			text: '',
		},
		subtitle: {
			text: '<a href="http://code.highcharts.com/mapdata/countries/us/us-all.js"></a>',
		},
		mapNavigation: {
			enabled: true,
			buttonOptions: {
				alignTo: 'spacingBox',
			},
		},
		legend: {
			enabled: true,
		},
		colorAxis: {
			min: 0,
		},
		series: [
			{
				type: 'map',
				states: {
					hover: {
						color: '#BADA55',
					},
				},
				dataLabels: {
					enabled: true,
					format: '{point.value}',
				},
				allAreas: false,
				data: [],
			},
		],
	};
	createRegionGraph(index) {
		let $this = this;
		$this.chartOptions.series[0] = {
			type: 'map',
			name: '',
			states: {
				hover: {
					color: '#BADA55',
				},
			},
			dataLabels: {
				enabled: true,
				format: '{point.properties.postal-code}',
			},
			allAreas: false,
			data: $this.page_summary_data['graphs_list'][index]['data'],
		};
		this.updateFlag = true;
	}

	createTreeMapGraph(index) {
		let $this = this;
		var options = {
		series: $this.page_summary_data['graphs_list'][index]['data'],
		colors: ['#008FFB'],
		chart: {
			height: 280,
			toolbar: {
				show: false,
			},
			zoom: {
				enabled: false,
			},
			type: 'heatmap',
			events: {
				dataPointSelection: function (event, chartContext, config) {
					// const details = {
					//   value: $this.graph_data["clients_by_both"][config.seriesIndex].data[config.dataPointIndex].x,
					//   value_id: $this.graph_data["clients_by_both"][config.seriesIndex].time_ids,
					//   closure: $this.graph_data["clients_by_both"][config.seriesIndex].name,
					//   closure_id: $this.graph_data["clients_by_both"][config.seriesIndex].data[config.dataPointIndex].value_ids,
					// };

					const details = {

							value: $this.page_summary_data['graphs_list'][index]['data'][config.seriesIndex].data[config.dataPointIndex].click_filter,
							value_id: $this.page_summary_data['graphs_list'][index]['data'][config.seriesIndex].data[config.dataPointIndex].click_filter,


							// Closure
							closure: $this.page_summary_data['graphs_list'][index]['data'][config.seriesIndex].click_filter,
							closure_id: $this.page_summary_data['graphs_list'][index]['data'][config.seriesIndex].click_filter,

					};

					// for (let filter_index = 0; filter_index < $this.page_summary_data['graphs_list'][index].filter_key.length; filter_index++) {
					// 	const filter_id = $this.page_summary_data['graphs_list'][index].filter_key[filter_index];
					// 	const filter_name = $this.page_summary_data['graphs_list'][index].filter_key_name[filter_index];
					// 	$this.page_summary_data['graphs_list'][index].filter_key[filter_index][filter_id] == details[filter_index].value_id ? "" :  details[filter_index].value_id;
					// 	$this.page_summary_data['graphs_list'][index].filter_key_name[filter_index][filter_name] == details[filter_index].value ? "" :  details[filter_index].value;
					// }


					const filter_id = [$this.page_summary_data['graphs_list'][index].filter_key[0], $this.page_summary_data['graphs_list'][index].filter_key[1]];
					const filter_name = [$this.page_summary_data['graphs_list'][index].filter_key_name[0], $this.page_summary_data['graphs_list'][index].filter_key_name[1]];

					$this.page_summary_data['graphs_list'][index][filter_id[0]] = $this.page_summary_data['graphs_list'][index][filter_id[0]] == details.value_id ? '' : details.value_id;

					$this.page_summary_data['graphs_list'][index][filter_name[0]] = $this.page_summary_data['graphs_list'][index][filter_name[0]] == details.value ? '' : details.value;

					$this.page_summary_data['graphs_list'][index][filter_id[1]] = $this.page_summary_data['graphs_list'][index][filter_id[1]] == details.closure_id ? '' : details.closure_id;
					$this.page_summary_data['graphs_list'][index][filter_name[1]] = $this.page_summary_data['graphs_list'][index][filter_name[1]] == details.closure ? '' : details.closure;


					$this.current_pagination_page = 1;
					$this.getTableData();
				},
			},
		},
		noData: {
			text: 'No Data Available',
			align: 'center',
			verticalAlign: 'middle',
			offsetX: 0,
			offsetY: 0,
			style: {
			color: '#006AFF',
			fontSize: '24px',
			fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
			},
		},
		plotOptions: {
			heatmap: {
			shadeIntensity: 0.5,
			radius: 0,
			useFillColorAsStroke: false,
			},
		},
		dataLabels: {
			enabled: false,
		},
		stroke: {
			width: 1,
		},
		title: {
			// text: 'HeatMap Chart with Color Range'
			text: '',
		},
		tooltip: {
			custom: function ({ series, seriesIndex, dataPointIndex, w }) {
				var closure_value = 'Value: ' + $this.page_summary_data['graphs_list'][index]['data'][seriesIndex].data[dataPointIndex].x + '<br>';

				var closure_time = 'Closure time: ' + $this.page_summary_data['graphs_list'][index]['data'][seriesIndex].name + '<br>';

				var count = 'Count: ' + $this.page_summary_data['graphs_list'][index]['data'][seriesIndex].data[dataPointIndex].y;

				return closure_value + closure_time + count;
			},
			// fixed: {
			//   enabled: true,
			//   position: "topRight"
			// }
		},
		};

		var chart = new ApexCharts(document.querySelector('#' + this.page_summary_data['graphs_list'][index].id), options);
		chart.render();
	}

	createPieGraph(index) {
		let $this = this;
		const options = {
			colors: $this.page_summary_data['graphs_list'][index]['data']['colors'],
			series: $this.page_summary_data['graphs_list'][index]['data']['data'],
			chart: {
				type: 'pie',
				events: {
					dataPointSelection: function (event, chartContext, config) {
						const details = {
							id: $this.page_summary_data['graphs_list'][index]['data']['click_filter'][config.dataPointIndex],
							name: $this.page_summary_data['graphs_list'][index]['data']['labels'][config.dataPointIndex],
						};


						const filter_id = $this.page_summary_data['graphs_list'][index].filter_key;
						const filter_name = $this.page_summary_data['graphs_list'][index].filter_key_name;
						$this.page_summary_data['graphs_list'][index][filter_id] = $this.page_summary_data['graphs_list'][index][filter_id] == details.id ? '' : details.id;

						$this.page_summary_data['graphs_list'][index][filter_name] = $this.page_summary_data['graphs_list'][index][filter_name] == details.name ? '' : details.name;


						$this.current_pagination_page = 1;
						$this.getTableData();
					},
				},
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 330,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			plotOptions: {
				pie: {
					startAngle: 0
				}
			},
			dataLabels: {
				enabled: false,
			},
			labels: $this.page_summary_data['graphs_list'][index]['data']['labels'],
			legend: {
				position: 'bottom',
				enabled: false,
			},
			yaxis: {
				title: {
					text: '',
				},
			},
			fill: {
				opacity: 1,
			},
		};

		var chart = new ApexCharts(document.querySelector('#' + this.page_summary_data['graphs_list'][index].id), options);
		chart.render();
	}

	createStackedBarGraph(index) {
		let $this = this;
		var options = {
		  colors: $this.page_summary_data['graphs_list'][index]['data']['colors'],
		  series: $this.page_summary_data['graphs_list'][index]['data']['y-axis'],
		  chart: {
			type: 'bar',
			toolbar: {
			  show: false,
			},
			zoom: {
			  enabled: false,
			},
			height: 280,
		  },
		  noData: {
			text: 'No Data Available',
			align: 'center',
			verticalAlign: 'middle',
			offsetX: 0,
			offsetY: 0,
			style: {
			  color: '#006AFF',
			  fontSize: '24px',
			  fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
			},
		  },
		  plotOptions: {
			bar: {
			  horizontal: false,
			  columnWidth: $this.commonService.getBarGraphPercentWidth(
				document.getElementById( $this.page_summary_data['graphs_list'][index]['id']).clientWidth,
				$this.page_summary_data['graphs_list'][index]['data']['x-axis'].length,
				20,
			  ),
			  endingShape: 'rounded',
			},
		  },
		  dataLabels: {
			enabled: false,
		  },
		  stroke: {
			show: true,
			width: 0,
			colors: ['transparent'],
		  },
		  xaxis: {
			categories: $this.page_summary_data['graphs_list'][index]['data']['x-axis'],
			title: {
			  text: '',
			},
			crosshairs: {
			  show: false,
			},
		  },
		  yaxis: {
			title: {
			//   text: 'Amount',
			},
			labels: {
			  // formatter: function (value) {
				// let val: string | number = Math.abs(value);
				// if (val >= 10 ** 3 && val < 10 ** 6) {
				//   val = (val / 1000).toFixed(0) + 'K';
				// } else if (val >= 10 ** 6) {
				//   val = (val / 1000000).toFixed(0) + 'M';
				// } else {
				//   val = val;
				// }
				// return val;
			  // },
        formatter: (value: number) => {
          return this.commonService.labelFormatter(value);
        }
			},
		  },
		  fill: {
			opacity: 1,
		  },
		  tooltip: {
			y: {
			  // formatter: function (value) {
				// let val: string | number = Math.abs(value);
				// if (val >= 10 ** 3 && val < 10 ** 6) {
				//   val = (val / 1000).toFixed(0) + 'K';
				// } else if (val >= 10 ** 6) {
				//   val = (val / 1000000).toFixed(0) + 'M';
				// } else {
				//   val = val;
				// }
				// return val;
			  // },
        formatter: (value: number) => {
          return this.commonService.labelFormatter(value);
        }
			},
		  },
		};

		var chart = new ApexCharts(document.querySelector('#' + this.page_summary_data['graphs_list'][index].id), options);
		chart.render();
	}

	createRadarGraph(index) {
		let $this = this;
		// let label_colors: any = [];

		// for (let index = 0; index < $this.page_summary_data['graphs_list'][index]['data']["x-axis"].length; index++) {
		// 	label_colors.push("#000000");
		// }

		var options = {
			colors: $this.page_summary_data['graphs_list'][index]['data']['colors'],
			series: [{
				name: '',
				data: $this.page_summary_data['graphs_list'][index]['data']["y-axis"],
				// data: [10, 20, 30, 10, 40, 66, 11, 33, 22, 77],
			}],
			chart: {
				type: 'radar',
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 280,
			},
			plotOptions: {
				radar: {
				  size: 140,
				  offsetX: 0,
				  offsetY: 10,
				  polygons: {
					strokeColors: '#858a90',
					strokeWidth: 1,
					connectorColors: '#858a90',
					// fill: {
					// 	colors: ['#f8f8f8', '#fff']
					// }
				  }
				}
			  },
			title: {
				text: ''
			},
			yaxis: {
				// stepSize: 20
			},
			xaxis: {
				categories: $this.page_summary_data['graphs_list'][index]['data']["x-axis"],
				labels: {
					style: {
					//   colors: $this.page_summary_data['graphs_list'][index]['data']['colors']
					//   colors: label_colors
					  colors: []
					},
				},
			},
		};

		var chart = new ApexCharts(document.querySelector('#' + this.page_summary_data['graphs_list'][index].id), options);
		chart.render();
	}

	createDonutGraph(index) {
		let $this = this;
		const options = {
			colors: $this.page_summary_data['graphs_list'][index]['data']['colors'],
			series: $this.page_summary_data['graphs_list'][index]['data']['data'],
			chart: {
				type: $this.page_summary_data['graphs_list'][index]['type'],
				events: {
					dataPointSelection: function (event, chartContext, config) {
						const details = {
							id: $this.page_summary_data['graphs_list'][index]['data']['click_filter'][config.dataPointIndex],
							name: $this.page_summary_data['graphs_list'][index]['data']['click_filter'][config.dataPointIndex],
						};
						const filter_id = $this.page_summary_data['graphs_list'][index].filter_key;
						const filter_name = $this.page_summary_data['graphs_list'][index].filter_key_name;

						$this.page_summary_data['graphs_list'][index][filter_id] = $this.page_summary_data['graphs_list'][index][filter_id] == details.id ? '' : details.id;

						$this.page_summary_data['graphs_list'][index][filter_name] = $this.page_summary_data['graphs_list'][index][filter_name] == details.name ? '' : details.name;

						$this.current_pagination_page = 1;
						$this.getTableData();
					},
				},
				toolbar: {
					show: false,
				},
				zoom: {
					enabled: false,
				},
				height: 330,
			},
			noData: {
				text: 'No Data Available',
				align: 'center',
				verticalAlign: 'middle',
				offsetX: 0,
				offsetY: 0,
				style: {
					color: '#006AFF',
					fontSize: '24px',
					fontFamily: "'Poppins', sans-serif, 'Helvetica Neue', sans-serif",
				},
			},
			plotOptions: {
				pie: {
					startAngle: 0
				}
			},
			dataLabels: {
				enabled: false,
			},
			labels: $this.page_summary_data['graphs_list'][index]['data']['labels'],
			legend: {
				position: 'bottom',
				enabled: false,
			},
			yaxis: {
				title: {
					text: '',
				},
			},
			fill: {
				opacity: 1,
			},
		};
		var chart = new ApexCharts(document.querySelector('#' + this.page_summary_data['graphs_list'][index].id), options);
		chart.render();
	}

	interactions_data_type: any = "all";
	getInteractionsData(value) {
		if (this.stepper_stage.order == 2) {
			this.interactions_data_type = value;
			this.getTableData();
		}
	}

	selected_alphabet = '';
 	 alphabets_array = [ 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', ];
	current_pagination_page = 1;
	total_pagination_records = 0;
	pagination_records_limit: any = 10;
	show_search: boolean = false;
	search_key: any = "";
	table_columns: any = [];
	table_data: any = [];
	table_columns_data: any = [];
	selected_table_data: any = [];
	table_data_loaded: boolean = false;
	show_toggle_columns: boolean = false;

	getTableData() {

		this.show_activity_view = null;
		this.show_proposal_view = null;

		this.table_data_loaded = false;


		let route: any = "";
		if ((this.selected_tab == "MAGI") && (this.user_details.role.role == 8 || this.user_details.role.role == 13 || this.user_details.role.role == 14)) {

      if (this.type == "Upside Opportunities") {
        route = "/client?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&advisor=" + this.user_details.id;

        route = route + '&clients_by_analysis_opportunity=' + this.opp_breakdown_id + '&clients_by_rulebased_trigger=' + this.rules_breakdown_id + '&clients_by_aibased_trigger=' + this.ai_breakdown_id + '&clients_by_both_trigger=' + this.common_breakdown_id;

        route = route + "&client_type=" + this.type;

      } else if (this.type == "Retention Opportunities") {
        route = "/client?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&advisor=" + this.user_details.id;

        route = route + '&clients_by_analysis_opportunity=' + this.opp_breakdown_id + '&clients_by_rulebased_trigger=' + this.rules_breakdown_id + '&clients_by_aibased_trigger=' + this.ai_breakdown_id + '&clients_by_both_trigger=' + this.common_breakdown_id;

         route = route + "&client_type=" + this.type;

      } else if (this.type == "Bank Customers to Investment Clients") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&stepper_stage=" + this.stepper_stage.id + "&order=" + this.stepper_stage.order + "&business_plan_id=" + this.business_plan + "&advisor=" + this.user_details.id;

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;

        route = route + "&prospect_type=New";

        route = route + "&client_type=" + this.type;

      } else if (this.type == "New Prospects" && this.user_details.role.business_area[0] == 5) {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&stepper_stage=" + this.stepper_stage.id + "&order=" + this.stepper_stage.order + "&business_plan_id=" + this.business_plan + "&advisor=" + this.user_details.id;

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;

        route = route + "&prospect_type=New Prospect";

        route = route + "&client_type=" + this.type;

      }  else if (this.type == "New Prospects" && this.user_details.role.business_area[0] != 5) {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&order=" + this.stepper_stage.order + "&business_plan_id=" + this.business_plan + "&advisor=" + this.user_details.id;

        route = route + "&prospect_type=non_members_magi";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;

      } else if (this.type == "Bank Customers to Deposit Clients") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&order=" + this.stepper_stage.order + "&business_plan_id=" + this.business_plan + "&advisor=" + this.user_details.id;

        route = route + "&prospect_type=members_magi";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;

      } else if (this.type == "Bank Customers to Lending Clients") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&stepper_stage=" + this.stepper_stage.id + "&order=" + this.stepper_stage.order + "&business_plan_id=" + this.business_plan + "&advisor=" + this.user_details.id;

        route = route + "&prospect_type=lending_magi";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;

      } else if (this.type == "Bank Customers to Insurance Clients") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&stepper_stage=" + this.stepper_stage.id + "&order=" + this.stepper_stage.order + "&business_plan_id=" + this.business_plan + "&advisor=" + this.user_details.id;

        route = route + "&prospect_type=insurance_magi";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;

      } else if (this.type == "Non Customers") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&stepper_stage=" + this.stepper_stage.id + "&order=" + this.stepper_stage.order + "&business_plan_id=" + this.business_plan + "&advisor=" + this.user_details.id;

        route = route + "&prospect_type=non_members_magi";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;
      }
    } else {
      if (this.type == "Upside Opportunities") {
        route = "/client?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&stepper_stage=" + this.stepper_stage.id + "&stepper_type=" + this.stepper_stage.type + "&order=" + this.stepper_stage.order + "&advisor=" + this.user_details.id;

        route = route + '&clients_by_analysis_opportunity=' + this.opp_breakdown_id + '&clients_by_rulebased_trigger=' + this.rules_breakdown_id + '&clients_by_aibased_trigger=' + this.ai_breakdown_id + '&clients_by_both_trigger=' + this.common_breakdown_id;

      } else if (this.type == "Retention Opportunities") {
        route = "/client?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&stepper_stage=" + this.stepper_stage.id + "&stepper_type=" + this.stepper_stage.type + "&order=" + this.stepper_stage.order + "&advisor=" + this.user_details.id + "&clients_by_attrition=true";

        route = route + '&clients_by_analysis_opportunity=' + this.opp_breakdown_id + '&clients_by_rulebased_trigger=' + this.rules_breakdown_id + '&clients_by_aibased_trigger=' + this.ai_breakdown_id + '&clients_by_both_trigger=' + this.common_breakdown_id;

      // } else if (this.type == "Institutional Customers to Investment Clients") {
      } else if (this.type == "Bank Customers to Investment Clients") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&stepper_stage=" + this.stepper_stage.id + "&order=" + this.stepper_stage.order + "&business_plan_id=" + this.business_plan + "&advisor=" + this.user_details.id;

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;

        route = route + "&prospect_type=New";

      } else if (this.type == "New Prospects") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&stepper_stage=" + this.stepper_stage.id + "&order=" + this.stepper_stage.order + "&business_plan_id=" + this.business_plan + "&advisor=" + this.user_details.id;

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;

        route = route + "&prospect_type=New Prospect";

      // } else if (this.type == "Institutional Customers to Deposit Clients") {
      } else if (this.type == "Bank Customers to Deposit Clients") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&stepper_stage=" + this.stepper_stage.id + "&order=" + this.stepper_stage.order + "&business_plan_id=" + this.business_plan + "&advisor=" + this.user_details.id;

        route = route + "&prospect_type=members";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;

      } else if (this.type == "Non Customers") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&stepper_stage=" + this.stepper_stage.id + "&order=" + this.stepper_stage.order + "&business_plan_id=" + this.business_plan + "&advisor=" + this.user_details.id;

        route = route + "&prospect_type=non_members";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;
      } else if (this.type == "Upside Opportunities MAGI") {
        route = "/client?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&stepper_type=opportunity" + "&ai_advisor_assistant=true" + "&advisor=" + this.user_details.id + "&opp_year=" + this.selected_opportunity_period + "&agi_screen=true";

        route = route + '&clients_by_analysis_opportunity=' + this.opp_breakdown_id + '&clients_by_rulebased_trigger=' + this.rules_breakdown_id + '&clients_by_aibased_trigger=' + this.ai_breakdown_id + '&clients_by_both_trigger=' + this.common_breakdown_id;
      } else if (this.type == "Retention Opportunities MAGI") {
        route = "/client?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&stepper_type=retention" + "&ai_advisor_assistant=true" + "&advisor=" + this.user_details.id + "&opp_year=" + this.selected_opportunity_period + "&agi_screen=true";

        route = route + '&clients_by_analysis_opportunity=' + this.opp_breakdown_id + '&clients_by_rulebased_trigger=' + this.rules_breakdown_id + '&clients_by_aibased_trigger=' + this.ai_breakdown_id+ '&clients_by_both_trigger=' + this.common_breakdown_id;

        route =  route + '&clients_by_attrition=true';

      } else if (this.type == "Bank Customers to Investment Clients MAGI") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&stepper_type=new" + "&ai_advisor_assistant=true" + "&advisor=" + this.user_details.id + "&opp_year=" + this.selected_opportunity_period + "&agi_screen=true";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;
      } else if (this.type == "New Prospects MAGI") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&stepper_type=new_prospect" + "&ai_advisor_assistant=true" + "&advisor=" + this.user_details.id + "&opp_year=" + this.selected_opportunity_period + "&agi_screen=true";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;
      } else if (this.type == "Bank Customers to Deposit Clients MAGI") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&stepper_type=members" + "&ai_advisor_assistant=true" + "&advisor=" + this.user_details.id + "&opp_year=" + this.selected_opportunity_period + "&agi_screen=true";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;
      } else if (this.type == "Non Customers MAGI") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&stepper_type=non_members" + "&ai_advisor_assistant=true" + "&advisor=" + this.user_details.id + "&opp_year=" + this.selected_opportunity_period + "&agi_screen=true";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;
      } else if (this.type == "Advisor Manager Bank Customers to Investment Clients MAGI") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&stepper_type=new" + "&ai_advisor_assistant=true" + "&opp_year=" + this.selected_opportunity_period + "&agi_screen=true&user_type=Advisor Manager";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;
      } else if (this.type == "Advisor Manager New Prospects MAGI") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&stepper_type=new_prospect" + "&ai_advisor_assistant=true" + "&opp_year=" + this.selected_opportunity_period + "&agi_screen=true&user_type=Advisor Manager";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;
      } else if (this.type == "Advisor Manager Bank Customers to Deposit Clients MAGI") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&stepper_type=members" + "&ai_advisor_assistant=true" + "&opp_year=" + this.selected_opportunity_period + "&agi_screen=true&user_type=Advisor Manager";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;
      } else if (this.type == "Advisor Manager Non Customers MAGI") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&stepper_type=non_members" + "&ai_advisor_assistant=true" + "&opp_year=" + this.selected_opportunity_period + "&agi_screen=true&user_type=Advisor Manager";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;
      } else if (this.type == "Marketing Team Bank Customers to Investment Clients Unassigned") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&prospect_type=new" + "&ai_advisor_assistant=true" + "&assigned_status=false" + "&responses=" + this.responded_type + "&opp_year=" + this.selected_opportunity_period + "&user_type=Marketing Team";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;
      } else if (this.type == "Marketing Team New Prospects Unassigned") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&prospect_type=new_prospect" + "&ai_advisor_assistant=true" + "&assigned_status=false" + "&responses=" + this.responded_type + "&opp_year=" + this.selected_opportunity_period + "&user_type=Marketing Team";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;
      } else if (this.type == "Marketing Team New Prospects - Investments Unassigned") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&prospect_type=new_prospect" + "&ai_advisor_assistant=true" + "&assigned_status=false" + "&responses=" + this.responded_type + "&opp_year=" + this.selected_opportunity_period + "&user_type=Marketing Team";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;
      } else if (this.type == "Marketing Team Bank Customers to Deposit Clients Unassigned") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&prospect_type=members" + "&ai_advisor_assistant=true" + "&assigned_status=false" + "&responses=" + this.responded_type + "&opp_year=" + this.selected_opportunity_period + "&user_type=Marketing Team";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;
      } else if (this.type == "Marketing Team Non Customers Unassigned") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&prospect_type=non_members" + "&ai_advisor_assistant=true" + "&assigned_status=false" + "&responses=" + this.responded_type + "&opp_year=" + this.selected_opportunity_period + "&user_type=Marketing Team";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;
      } else if (this.type == "Marketing Team New Prospects - Deposits Unassigned") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&prospect_type=non_members" + "&ai_advisor_assistant=true" + "&assigned_status=false" + "&responses=" + this.responded_type + "&opp_year=" + this.selected_opportunity_period + "&user_type=Marketing Team";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;
      } else if (this.type == "Marketing Team Bank Customers to Investment Clients Assigned") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&prospect_type=new" + "&ai_advisor_assistant=false" + "&assigned_status=true" + "&opp_year=" + this.selected_opportunity_period + "&user_type=Marketing Team";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;
      } else if (this.type == "Marketing Team New Prospects Assigned") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&prospect_type=new_prospect" + "&ai_advisor_assistant=false" + "&assigned_status=true" + "&opp_year=" + this.selected_opportunity_period + "&user_type=Marketing Team";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;
      } else if (this.type == "Marketing Team New Prospects - Investments Assigned") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&prospect_type=new_prospect" + "&ai_advisor_assistant=false" + "&assigned_status=true" + "&opp_year=" + this.selected_opportunity_period + "&user_type=Marketing Team";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;
      } else if (this.type == "Marketing Team Bank Customers to Deposit Clients Assigned") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&prospect_type=members" + "&ai_advisor_assistant=false" + "&assigned_status=true" + "&opp_year=" + this.selected_opportunity_period + "&user_type=Marketing Team";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;
      } else if (this.type == "Marketing Team Non Customers Assigned") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&prospect_type=non_members" + "&ai_advisor_assistant=false" + "&assigned_status=true" + "&opp_year=" + this.selected_opportunity_period + "&user_type=Marketing Team";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;
      } else if (this.type == "Marketing Team New Prospects - Deposits Assigned") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&prospect_type=non_members" + "&ai_advisor_assistant=false" + "&assigned_status=true" + "&opp_year=" + this.selected_opportunity_period + "&user_type=Marketing Team";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;
      } else if (this.type == "Marketing Team Bank Customers to Lending Clients Unassigned") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&prospect_type=lending" + "&ai_advisor_assistant=true" + "&assigned_status=false" + "&responses=" + this.responded_type + "&opp_year=" + this.selected_opportunity_period + "&user_type=Marketing Team";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;
      } else if (this.type == "Marketing Team New Prospects - Lending Unassigned") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&prospect_type=non_members" + "&ai_advisor_assistant=true" + "&assigned_status=false" + "&responses=" + this.responded_type + "&opp_year=" + this.selected_opportunity_period + "&user_type=Marketing Team";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;
      } else if (this.type == "Marketing Team Bank Customers to Lending Clients Assigned") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&prospect_type=lending" + "&ai_advisor_assistant=false" + "&assigned_status=true" + "&opp_year=" + this.selected_opportunity_period + "&user_type=Marketing Team";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;
      } else if (this.type == "Marketing Team New Prospects - Lending Assigned") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&prospect_type=non_members" + "&ai_advisor_assistant=false" + "&assigned_status=true" + "&opp_year=" + this.selected_opportunity_period + "&user_type=Marketing Team";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;
      } else if (this.type == "Marketing Team Bank Customers to Insurance Clients Unassigned") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&prospect_type=insurance" + "&ai_advisor_assistant=true" + "&assigned_status=false" + "&responses=" + this.responded_type + "&opp_year=" + this.selected_opportunity_period + "&user_type=Marketing Team";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;
      } else if (this.type == "Marketing Team New Prospects - Insurance Unassigned") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&prospect_type=non_members" + "&ai_advisor_assistant=true" + "&assigned_status=false" + "&responses=" + this.responded_type + "&opp_year=" + this.selected_opportunity_period + "&user_type=Marketing Team";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;
      } else if (this.type == "Marketing Team Bank Customers to Insurance Clients Assigned") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&prospect_type=insurance" + "&ai_advisor_assistant=false" + "&assigned_status=true" + "&opp_year=" + this.selected_opportunity_period + "&user_type=Marketing Team";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;
      } else if (this.type == "Marketing Team New Prospects - Insurance Assigned") {
        route = "/prospect?records_per_page=" + this.pagination_records_limit + "&page=" + this.current_pagination_page + "&search=" + this.search_key + "&prospect_type=non_members" + "&ai_advisor_assistant=false" + "&assigned_status=true" + "&opp_year=" + this.selected_opportunity_period + "&user_type=Marketing Team";

        route = route + '&prospects_by_analysis_opportunity=' + this.opp_breakdown_id + '&prospects_by_rulebased_trigger=' + this.rules_breakdown_id + '&prospects_by_aibased_trigger=' + this.ai_breakdown_id + '&prospects_by_both_trigger=' + this.common_breakdown_id;
      }
    }

		if (this.stepper_stage.order == 2 && this.selected_tab != "MAGI" && this.user_details.role.role != 8 && this.user_details.role.role != 13 && this.user_details.role.role != 14) {
			route = route + "&active_interactions=" + this.interactions_data_type;
		}

		if (this.stepper_stage.position == 'last') {
			route = route + "&is_last=true";
		}

		for (let index = 0; index < this.page_summary_data["graphs_list"].length; index++) {
			const graph_data = this.page_summary_data["graphs_list"][index];
			if (graph_data.type != "tree") {
				if (graph_data[graph_data.filter_key[0]] && graph_data[graph_data.filter_key[0]] != '' && graph_data[graph_data.filter_key[0]] != null) {
					route = route + "&" + graph_data.filter_key[0] + "=" + graph_data[graph_data.filter_key[0]];
				}

				if ((graph_data.filter_key[0] == "yearly_filter")  && (graph_data[graph_data.filter_key[0]] == '' || graph_data[graph_data.filter_key[0]] == null)) {
					route = route + "&opp_year=" + this.selected_opportunity_period;
				}

			} else {
				if (graph_data[graph_data.filter_key[0]] && graph_data[graph_data.filter_key[0]] != '' && graph_data[graph_data.filter_key[0]] != null) {
					route = route + "&" + graph_data.filter_key[0] + "=" + graph_data[graph_data.filter_key[0]];
				}

				if (graph_data[graph_data.filter_key[1]] && graph_data[graph_data.filter_key[1]] != '' && graph_data[graph_data.filter_key[1]] != null) {
					route = route + "&" + graph_data.filter_key[1] + "=" + graph_data[graph_data.filter_key[1]];
				}



			}
		}

		if (this.stepper_stage.order > 2) {
			route = route + "&opp_year=" + this.selected_opportunity_period;
		}



		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.table_columns = res["results"]['columns'];
				// for (let index = 0; index < this.table_columns.length; index++) {
				if (this.table_columns.length > 0) {
					let limit: any = 9;

					if (limit > this.table_columns.length) {
						limit = this.table_columns.length;
					}

					for (let index = 0; index < limit; index++) {
						this.table_columns[index].checked = true;
					}
				}
				// this.table_data = res['results']['data'];
				this.table_data = res['results']['data'];
				this.current_pagination_page = res["page_number"];
				this.total_pagination_records = res["total_no_of_records"];
				this.table_data_loaded = true;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	getKey(data, column) {
		const key = column['key'];
		return data[key];
	}

	pageChanged(event) {

		this.show_activity_view = null;
		this.show_proposal_view = null;

		this.selected_table_data = [];
		this.current_pagination_page = event;
		this.pagination_records_limit = this.pagination_records_limit;
		this.getTableData();
	}

	abbreviateNumber(value) {
		let fixed = 1;
		let num = value;
		if (num === null) {
			return null;
		}
		if (num === 0) {
			return '0';
		}
		fixed = !fixed || fixed < 0 ? 0 : fixed;
		var b = num.toPrecision(2).split('e'),
			k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
			c =
			k < 1
				? num.toFixed(0 + fixed)
				: (num / Math.pow(10, k * 3)).toFixed(1 + fixed),
			d = c < 0 ? c : Math.abs(c),
			e = d + ['', 'K', 'M', 'B', 'T'][k];
		return e;

		// value = Math.round(value);
		// let new_value = value;
		// if (value >= 1000) {
		//     const suffixes = ["", "K", "M", "B","T"];
		//     const suffixNum = Math.floor( (""+value).length/3 );
		//     let shortValue: any = '';
		//     for (var precision = 2; precision >= 1; precision--) {
		//         shortValue = parseFloat( (suffixNum != 0 ? (value / Math.pow(1000,suffixNum) ) : value).toPrecision(precision));
		//         var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
		//         if (dotLessShortValue.length <= 2) { break; }
		//     }
		//     if (shortValue % 1 != 0)  shortValue = shortValue.toFixed(1);
		//     new_value = shortValue+suffixes[suffixNum];
		// }
		// return new_value;
	}

	show_activity_view: number = null;
	toggleActivityView(value) {
		this.show_proposal_view = null;
		if (this.show_activity_view == value) {
			this.show_activity_view = null;
		} else {
			this.show_activity_view = value;
		}
	}

	show_proposal_view: number = null;
	toggleProposalView(value) {
		this.show_activity_view = null;
		this.proposals_list = [];
		if (this.show_proposal_view == value) {
			this.show_proposal_view = null;
		} else {
			this.show_proposal_view = value;
			this.getProposalsList();
		}
	}

	proposals_list: any = [];
	proposals_list_loaded: boolean = false;
	getProposalsList() {
		this.proposals_list_loaded = false;
		let route: any = "";

		const data = this.table_data[this.show_proposal_view];

		if (this.type == "Upside Opportunities") {
			route = "/proposal?client=" + data.id + "&advisor=" + this.user_details.id + "&no_page=true";

		} else if (this.type == "Retention Opportunities") {
			route = "/proposal?client=" + data.id + "&advisor=" + this.user_details.id + "&no_page=true";
		} else if (this.type == "Bank Customers to Investment Clients") {
			route = "/proposal?prospect=" + data.id + "&advisor=" + this.user_details.id + "&no_page=true";

		} else if (this.type == "New Prospects") {
			route = "/proposal?prospect=" + data.id + "&advisor=" + this.user_details.id + "&no_page=true";
		} else if (this.type == "Bank Customers to Deposit Clients") {
			route = "/proposal?prospect=" + data.id + "&advisor=" + this.user_details.id + "&no_page=true";

		} else if (this.type == "Non Customers") {
			route = "/proposal?prospect=" + data.id + "&advisor=" + this.user_details.id + "&no_page=true";
		} else if (this.type == "Upside Opportunities MAGI") {
			route = "/proposal?client=" + data.id + "&advisor=" + this.user_details.id + "&no_page=true";
		} else if (this.type == "Retention Opportunities MAGI") {
			route = "/proposal?client=" + data.id + "&advisor=" + this.user_details.id + "&no_page=true";
		} else if (this.type == "Bank Customers to Investment Clients MAGI") {
			route = "/proposal?prospect=" + data.id + "&advisor=" + this.user_details.id + "&no_page=true";
		} else if (this.type == "New Prospects MAGI") {
			route = "/proposal?prospect=" + data.id + "&advisor=" + this.user_details.id + "&no_page=true";
		} else if (this.type == "Bank Customers to Deposit Clients MAGI") {
			route = "/proposal?prospect=" + data.id + "&advisor=" + this.user_details.id + "&no_page=true";
		} else if (this.type == "Non Customers MAGI") {
			route = "/proposal?prospect=" + data.id + "&advisor=" + this.user_details.id + "&no_page=true";
		}

		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.proposals_list = res;
				this.proposals_list_loaded = true;
			},
			(err) => {
				this.proposals_list = [];
				this.proposals_list_loaded = true;
				this.commonService.showToast('error', err.error);
			},
		);
	}

	@Output() stepperChange = new EventEmitter<any>();
	changeStepper() {
		this.stepperChange.emit(this.stepper_stage);
	}

	show_page_graphs: boolean = false;
	createGraphs() {
		if (this.show_page_graphs == true) {
		  this.getPageSummary();
		}
	}

	back() {
		const data = {
			clickable: true,
			name: 'Summary',
		};
		this.stateChanged.emit(data);
	}

	is_selected: boolean = false;
	selectAll(event) {
		if (event.checked == true) {
			this.selected_table_data = JSON.parse(JSON.stringify(this.table_data));
			this.is_selected = true;
		} else {
			this.selected_table_data = [];
			this.is_selected = false;
		}
	}

	checkIndividualSelection(data) {
		const index = this.selected_table_data.findIndex((obj) => obj.id == data.id);
		if (index != -1) {
			return true;
		} else {
			return false;
		}
	}

	selectIndividual(event, data) {
		const index = this.selected_table_data.findIndex((obj) => obj.id == data.id);
		if (index != -1) {
			if (event.checked == true) {
				this.selected_table_data.splice(index, 0, data);
			} else {
				this.selected_table_data.splice(index, 1);
			}
		} else {
			this.selected_table_data.splice(index, 0, data);
		}

		if (this.table_data.length == this.selected_table_data.length) {
			this.is_selected = true;
		} else {
			this.is_selected = false;
		}
	}

	move_record_error: boolean = false;
  	@ViewChild('moveRecordModal') moveRecordModal: TemplateRef<any>;
	private moveRecordModalRef: MatDialogRef<TemplateRef<any>>;
	openMoveRecordModal() {
		if (this.selected_table_data.length > 0) {
			this.moveRecordModalRef = this.dialog.open(this.moveRecordModal, { disableClose: true });
			this.moveRecordModalRef.afterClosed().subscribe((result) => {
				this.closeMoveRecordModal();
			});
			this.move_record_error = false;
		} else {
			this.move_record_error = true;
		}
	}

	closeMoveRecordModal() {
		this.moveRecordModalRef.close();
		this.move_record_error = false;
		this.move_record_stage = "";
		this.move_record_stage_error = false;
	}

	stages_data: any = [];
	getStages() {
		// let type: any = "";
		// if (this.type == "Upside Opportunities") {
		// 	type = "opportunity";
		// } else if (this.type == "Retention Opportunities") {
		// 	type = "retention";
		// } else if (this.type == "Institutional Customers to Investment Clients") {
		// 	type = "new";
		// }

		this.commonService.getData('/stage?no_page=true&financial_institution=' + this.user_details.financial_institution + '&current_stage=' + this.stepper_stage.id + "&type=" + this.stepper_stage.type + "&business_area=" + this.user_details.role.business_area[0]).subscribe(
			(res: any) => {
				this.stages_data = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	move_record_stage: any = "";
	move_record_stage_error: boolean = false;
	// move_record_stage_activity_status: boolean = false;
	move_record_stage_activity_status: boolean = true;
	changeClientStage() {
		if (this.move_record_stage != "" && this.move_record_stage != null) {
			this.move_record_stage_error = false;
		} else {
			this.move_record_stage_error = true;
		}

		let payload: any = {
			current_stage: this.stepper_stage.id,
			target_stage: this.move_record_stage,
			client_list: [],
			not_required: this.move_record_stage_activity_status,
			type: ""
		};

		if (this.type == "Upside Opportunities") {
			payload.type = "opportunity";
		} else if (this.type == "Retention Opportunities") {
			payload.type = "retention";
		// } else if (this.type == "Institutional Customers to Investment Clients") {
		} else if (this.type == "Bank Customers to Investment Clients") {
			payload.type = "new";
		// } else if (this.type == "Institutional Customers to Deposit Clients") {
		} else if (this.type == "Bank Customers to Deposit Clients") {
			payload.type = "members";
		} else if (this.type == "Non Customers") {
			payload.type = "non_members";
		}

		for (let index = 0; index < this.selected_table_data.length; index++) {
			payload.client_list.push(this.selected_table_data[index].id);
		}

		if (this.move_record_stage_error == false) {
			this.commonService.postData("/movestage/", payload).subscribe(
				(res: any) => {
					this.commonService.showToast('success', 'Stage Changed Successfully.');
					this.closeMoveRecordModal();
					this.selected_table_data = [];
					this.is_selected = false;
					this.changeStepper();
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);
		}
	}

	// Send Proposal
	@ViewChild('sendProposalModal') sendProposalModal: TemplateRef<any>;
	private sendProposalModalRef: MatDialogRef<TemplateRef<any>>;
	send_proposal_type: any = "";
	send_proposal_client: any;
	// openSendProposalModal(type) {
	// 	if (this.selected_table_data.length > 0) {
	// 		this.send_proposal_type = JSON.parse(JSON.stringify(type));
	// 		this.sendProposalModalRef = this.dialog.open(this.sendProposalModal, { disableClose: true });
	// 		this.sendProposalModalRef.afterClosed().subscribe((result) => {
	// 			this.closeSendProposalModal();
	// 		});
	// 		this.move_record_error = false;
	// 	} else {
	// 		this.move_record_error = true;
	// 	}
	// }

	openSendProposalModal(type, data) {
		this.send_proposal_type = JSON.parse(JSON.stringify(type));
		this.send_proposal_client = JSON.parse(JSON.stringify(data));


		if (this.send_proposal_type == "Send") {
			this.proposal_data.objective_code = this.send_proposal_client.objective_code;
		} else if (this.send_proposal_type == "Resend") {
			this.proposal_data.objective_code = this.send_proposal_client.objective_code;
			this.proposal_data.product = this.send_proposal_client.product;
		}

		this.sendProposalModalRef = this.dialog.open(this.sendProposalModal, { disableClose: true });
		this.sendProposalModalRef.afterClosed().subscribe((result) => {
			this.closeSendProposalModal();
		});
	}

	closeSendProposalModal() {
		this.sendProposalModalRef.close();
		this.move_record_error = false;
		this.proposal_data = {
			objective_code: "",
			product: "",
			scheduled_date: new Date(),
			description: "",
			files: [],
			subject: "",
			email_body: ""
		};
		this.proposal_data_errors = {
			objective_code: false,
			product: false,
			scheduled_date: false,
			description: false,
			files: false,
			subject: false,
			email_body: false
		};
		this.move_record_stage_activity_status = false;
		this.send_proposal_type = "";
		this.send_proposal_client = {};
	}

	@ViewChild('proposalFile') proposalFile;
	uploadProposalFile(event)  {
		for (let index = 0; index < event.target.files.length; index++) {
			this.proposal_data.files.push({
				name: event.target.files[index].name,
				file: event.target.files[index]
			});
		}
		// this.proposal_data.files.push({
		// 	name: event.target.files[0].name,
		// 	file: event.target.files[0]
		// });
		this.proposalFile.nativeElement.value = '';
	}

	deleteProposalFile(index)  {
		this.proposal_data.files.splice(index, 1);
	}

	editorConfig: any = {
		editable: true,
		  spellcheck: true,
		  height: 'auto',
		  minHeight: '0',
		  maxHeight: 'auto',
		  width: 'auto',
		  minWidth: '0',
		  translate: 'yes',
		  enableToolbar: true,
		  showToolbar: true,
		  placeholder: 'Enter text here...',
		  defaultParagraphSeparator: '',
		  defaultFontName: '',
		  defaultFontSize: '',
		  fonts: [
			{class: 'arial', name: 'Arial'},
			{class: 'times-new-roman', name: 'Times New Roman'},
			{class: 'calibri', name: 'Calibri'},
			{class: 'comic-sans-ms', name: 'Comic Sans MS'}
		  ],
		  customClasses: [
		  {
			name: 'quote',
			class: 'quote',
		  },
		  {
			name: 'redText',
			class: 'redText'
		  },
		  {
			name: 'titleText',
			class: 'titleText',
			tag: 'h1',
		  },
		],
		sanitize: true,
		toolbarPosition: 'top',
		toolbarHiddenButtons: [
		  // ['bold', 'italic'],
		  // ['fontSize']
		  ['insertImage', 'insertVideo',]
		]
	};
	proposal_data: any = {
		objective_code: "",
		product: "",
		scheduled_date: new Date(),
		description: "",
		files: [],
		subject: "",
		email_body: ""
	};
	proposal_data_errors: any = {
		objective_code: false,
		product: false,
		scheduled_date: false,
		description: false,
		files: false,
		subject: false,
		email_body: false
	};
	current_date: any = new Date();
	sendProposal() {

		if (this.proposal_data.objective_code != "" && this.proposal_data.objective_code != null) {
			this.proposal_data_errors.objective_code = false;
		} else {
			this.proposal_data_errors.objective_code = true;
		}

		if (this.proposal_data.product != "" && this.proposal_data.product != null) {
			this.proposal_data_errors.product = false;
		} else {
			this.proposal_data_errors.product = true;
		}

		if (this.proposal_data.scheduled_date != "" && this.proposal_data.scheduled_date != null) {
			this.proposal_data_errors.scheduled_date = false;
		} else {
			this.proposal_data_errors.scheduled_date = true;
		}

		// if (this.proposal_data.description != "" && this.proposal_data.description != null) {
		// 	this.proposal_data_errors.description = false;
		// } else {
		// 	this.proposal_data_errors.description = true;
		// }

		if (this.proposal_data.subject != "" && this.proposal_data.subject != null) {
			this.proposal_data_errors.subject = false;
		} else {
			this.proposal_data_errors.subject = true;
		}

		if (this.proposal_data.email_body != "" && this.proposal_data.email_body != null) {
			this.proposal_data_errors.email_body = false;
		} else {
			this.proposal_data_errors.email_body = true;
		}

		if (this.proposal_data.files.length > 0) {
			this.proposal_data_errors.files = false;
		} else {
			this.proposal_data_errors.files = true;
		}

		if (
			this.proposal_data_errors.objective_code == false &&
			this.proposal_data_errors.product == false &&
			this.proposal_data_errors.scheduled_date == false &&
			// this.proposal_data_errors.description == false &&
			this.proposal_data_errors.subject == false &&
			this.proposal_data_errors.email_body == false &&
			this.proposal_data_errors.files == false
		) {
			let payload: any = {
				type: "",
				description: this.proposal_data.description,
				objective_code: this.proposal_data.objective_code,
				product: this.proposal_data.product,
				client_list: [],
				scheduled_date: moment(this.proposal_data.scheduled_date).format(),
				not_required: this.move_record_stage_activity_status,
				subject: this.proposal_data.subject,
				email_body: this.proposal_data.email_body,
			};

			if (this.type == "Upside Opportunities") {
				payload.type = "opportunity";
			} else if (this.type == "Retention Opportunities") {
				payload.type = "retention";
			// } else if (this.type == "Institutional Customers to Investment Clients") {
			} else if (this.type == "Bank Customers to Investment Clients") {
				payload.type = "new";
			// } else if (this.type == "Institutional Customers to Deposit Clients") {
			} else if (this.type == "Bank Customers to Deposit Clients") {
				// payload.type = "members";
				payload.type = "new";
			} else if (this.type == "Non Customers") {
				// payload.type = "non_members";
				payload.type = "new";
			}

			// for (let index = 0; index < this.selected_table_data.length; index++) {
			// 	payload.client_list.push(this.selected_table_data[index].id);
			// }

			if (this.send_proposal_type == "Send") {
				payload.client_id = this.send_proposal_client.id;
			} else if (this.send_proposal_type == "Resend") {
				payload.client_id = this.send_proposal_client.client;
			}

			// payload.client_id = this.send_proposal_client.id;

			const formData = new FormData();
    		// formData.append('client_list', payload.client_list);
    		formData.append('client_id', payload.client_id);
    		formData.append('type', payload.type);
    		formData.append('description', payload.description);
    		formData.append('objective_code', payload.objective_code);
    		formData.append('product', payload.product);
    		formData.append('scheduled_date', payload.scheduled_date);
    		formData.append('not_required', payload.not_required);
    		formData.append('files_count', this.proposal_data.files.length);
    		formData.append('subject', payload.subject);
    		formData.append('email_body', payload.email_body);

			for (let index = 0; index < this.proposal_data.files.length; index++) {
				const key = "proposal_file_" + (index +  1);
				formData.append(key, this.proposal_data.files[index].file);
			}

			let route: any = "";
			if (this.send_proposal_type == "Send") {
				// route = "/sendproposal/";
				route = "/sendproposal_new/";
			} else if (this.send_proposal_type == "Resend") {
				// route = "/resendproposal/";
				route = "/resendproposal_new/";
			}

			this.commonService.postData(route, formData).subscribe(
				(res: any) => {
					this.closeSendProposalModal();
					this.selected_table_data = [];
					this.is_selected = false;
					this.current_pagination_page = 1;
					this.getPageSummary();
					this.changeStepper();
					this.commonService.showToast('success', "The document will be sent via email on the scheduled date.");
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);

		}
	}

	@ViewChild('viewProposalModal') viewProposalModal: TemplateRef<any>;
	private viewProposalModalRef: MatDialogRef<TemplateRef<any>>;
	view_proposal_data: any;
	viewProposal(proposal) {
		this.view_proposal_data =JSON.parse(JSON.stringify(proposal));
		this.viewProposalModalRef = this.dialog.open(this.viewProposalModal, { disableClose: true });
		this.viewProposalModalRef.afterClosed().subscribe((result) => {
			this.closeViewProposalModal();
		});
	}

	closeViewProposalModal() {
		this.viewProposalModalRef.close();
	}

	download(link) {
		window.open(environment.apiEndpoint + '/' + link, "_blank")
	}

	conversion_status_list: any = [];
	getConversionStatusList() {
		this.commonService.getData('/conversionStatus/?no_page=true').subscribe(
			(res: any) => {
				this.conversion_status_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	product_list: any = [];
	getProductList() {
		this.commonService.getData('/product/?no_page=true&business_area=' + this.user_details.role.business_area[0]).subscribe(
		(res: any) => {
			this.product_list = res;
		},
		(err) => {
			this.commonService.showToast('error', err.error);
		},
		);
	}

	client_product_status_list: any = [];
	getClientProductStatus() {
			this.commonService.getData('/clientProductStatus/?no_page=true').subscribe(
			(res: any) => {
				this.client_product_status_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	attrition_reasons_list: any = [];
	getAttritionReasons() {
		let route = '/attritionreasons?financial_institution=' + this.user_details.financial_institution + '&no_page=true' + '&business_area=' + this.user_details.role.business_area[0];
		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.attrition_reasons_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	objectives_list: any = [];
	getObjectives() {
		let route = '/getobjectives/';
		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.objectives_list = res["objectives"];
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}


	products_list: any = [];
	getProducts() {
		let route = '/product?no_page=true' + '&business_area=' + this.user_details.role.business_area[0];
		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.products_list = res;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

  advisor_teams_list: any = [];
  getAdvisorTeams() {
    this.commonService.getData("/get_all_teams/").subscribe(
      (res: any) => {
        this.advisor_teams_list = res["data"];
      },
      (err) => {
        this.commonService.showToast('error', err.error);
      },
    );
  }

	getProductType(id) {
		const index = this.product_list.findIndex((x) => x.id == id);
		if (index > -1) {
			// this.product_data.product_type = this.product_list[index].product_type;
			this.product_data.product_type = this.product_list[index].product_type;
			if (this.product_list[index].product_type == 'Life Time') {
				return false;
			} else {
				return true;
			}
		} else {
			return true;
		}
	}

	@ViewChild('closeDealModal') closeDealModal: TemplateRef<any>;
	private closeDealModalRef: MatDialogRef<TemplateRef<any>>;
	// openCloseDealModal() {
	// 	if (this.selected_table_data.length > 0) {
	// 		this.closeDealModalRef = this.dialog.open(this.closeDealModal, { disableClose: true });
	// 		this.closeDealModalRef.afterClosed().subscribe((result) => {
	// 			this.closeClientDealModal();
	// 			this.closeDepostClientDealModal();
	// 		});
	// 		this.move_record_error = false;
	// 	} else {
	// 		this.move_record_error = true;
	// 	}
	// }

	openCloseDealModal(client) {
		this.selected_table_data = [];
		this.selected_table_data.push(client);
		this.closeDealModalRef = this.dialog.open(this.closeDealModal, { disableClose: true });
		this.closeDealModalRef.afterClosed().subscribe((result) => {
			this.closeClientDealModal();
			this.closeDepostClientDealModal();
		});
	}

	closeClientDealModal() {
		this.closeDealModalRef.close();
		this.move_record_error = false;
		this.move_record_stage_activity_status = false;
		this.conversion_status_data = {
			conversion_status: '',
			conversion_comments: '',
		};
		this.conversion_status_data_errors = {
			conversion_status: false,
			conversion_comments: false,
		};
		this.product_data = {
			client_id: '',
			client_type: '',
			expected_aum: '',
			expected_closure_date: '',
			status: '',
			policy_number: '',
			aum: '',
			start_date: '',
			product: '',
			close_date: '',
			type: '',
			client_product_status: '',
			deposit_purpose: '',
		};
		this.product_data_errors = {
			client_id: false,
			client_type: false,
			expected_aum: false,
			expected_closure_date: false,
			status: false,
			policy_number: false,
			aum: false,
			start_date: false,
			product: false,
			close_date: false,
			type: false,
			client_product_status: false,
			deposit_purpose: false,
		};
		this.product_operation_type = "Add";
	}

	conversion_status_data: any = {
		conversion_status: '',
		conversion_comments: '',
	};
	conversion_status_data_errors: any = {
		conversion_status: false,
		conversion_comments: false,
	};

	product_data: any = {
		client_id: '',
		client_type: '',
		expected_aum: '',
		expected_closure_date: '',
		status: '',
		policy_number: '',
		aum: '',
		start_date: '',
		product: '',
		close_date: '',
		type: '',
		client_product_status: '',
		deposit_purpose: '',
	};
	product_data_errors: any = {
		client_id: false,
		client_type: false,
		expected_aum: false,
		expected_closure_date: false,
		status: false,
		policy_number: false,
		aum: false,
		start_date: false,
		product: false,
		close_date: false,
		type: false,
		client_product_status: false,
		deposit_purpose: false,
	};
	product_operation_type: any = "Add";
	validateProductInformation() {
		if (
			this.product_data.policy_number != '' &&
			this.product_data.policy_number != null
		) {
			this.product_data_errors.policy_number = false;
		} else {
			this.product_data_errors.policy_number = true;
		}

		if (
			this.product_data.aum != '' &&
			this.product_data.aum != null
		) {
			this.product_data_errors.aum = false;
		} else {
			this.product_data_errors.aum = true;
		}

		if (
			this.product_data.start_date != '' &&
			this.product_data.start_date != null
		) {
			this.product_data_errors.start_date = false;
		} else {
			this.product_data_errors.start_date = true;
		}

		if (
			this.product_data.product != '' &&
			this.product_data.product != null
		) {
			this.product_data_errors.product = false;
		} else {
			this.product_data_errors.product = true;
		}

		// if (this.product_data.close_date != "" && this.product_data.close_date != null) {
		//   this.product_data_errors.close_date = false;
		// } else {
		//   this.product_data_errors.close_date = true;
		// }

		if (
		this.product_data.product_type == 'Life Time' ||
		(this.product_data.close_date != '' &&
			this.product_data.close_date != null)
		) {
			this.product_data_errors.close_date = false;
		} else {
			this.product_data_errors.close_date = true;
		}

		if (
			this.product_data.type != '' &&
			this.product_data.type != null
		) {
			this.product_data_errors.type = false;
		} else {
			this.product_data_errors.type = true;
		}

		if (
			this.product_data.client_product_status != '' &&
			this.product_data.client_product_status != null
		) {
			this.product_data_errors.client_product_status = false;
		} else {
			this.product_data_errors.client_product_status = true;
		}

		if (this.user_role == "Relationship Manager") {
			if (
				this.product_data.deposit_purpose != '' &&
				this.product_data.deposit_purpose != null
			) {
				this.product_data_errors.deposit_purpose = false;
			} else {
				this.product_data_errors.deposit_purpose = true;
			}
		} else {
			this.product_data.deposit_purpose = "";
			this.product_data_errors.deposit_purpose = false;
		}

		if (
			this.product_data_errors.policy_number == false &&
			this.product_data_errors.aum == false &&
			this.product_data_errors.start_date == false &&
			this.product_data_errors.product == false &&
			this.product_data_errors.close_date == false &&
			this.product_data_errors.type == false &&
			this.product_data_errors.client_product_status == false &&
			this.product_data_errors.deposit_purpose == false
		) {
			return true;
		} else {
			return false;
		}
	}


	depositProduct_data: any = {
		client_id: '',
		client_type: '',
		expected_aum: '',
		expected_closure_date: '',
		status: '',
		policy_number: '',
		aum: '',
		start_date: '',
		product: '',
		close_date: '',
		type: '',
		client_product_status: '',
		deposit_purpose: '',
		interest_rate: '',
		monthly_fees: '',

	};
	depositProduct_data_errors: any = {
		client_id: '',
		client_type: '',
		expected_aum: '',
		expected_closure_date: '',
		status: '',
		policy_number: '',
		aum: '',
		start_date: '',
		product: '',
		close_date: '',
		type: '',
		client_product_status: '',
		deposit_purpose: '',
		interest_rate: '',
		monthly_fees: '',
	};

	depositProduct_operation_type: any = "Add";
	validateDepositProductInformation() {
		if (
			this.depositProduct_data.policy_number != '' &&
			this.depositProduct_data.policy_number != null
		) {
			this.depositProduct_data_errors.policy_number = false;
		} else {
			this.depositProduct_data_errors.policy_number = true;
		}

		if (
			this.depositProduct_data.aum != '' &&
			this.depositProduct_data.aum != null
		) {
			this.depositProduct_data_errors.aum = false;
		} else {
			this.depositProduct_data_errors.aum = true;
		}

		if (
			this.depositProduct_data.start_date != '' &&
			this.depositProduct_data.start_date != null
		) {
			this.depositProduct_data_errors.start_date = false;
		} else {
			this.depositProduct_data_errors.start_date = true;
		}

		if (
			this.depositProduct_data.product != '' &&
			this.depositProduct_data.product != null
		) {
			this.depositProduct_data_errors.product = false;
		} else {
			this.depositProduct_data_errors.product = true;
		}

		if (this.depositProduct_data.close_date != "" && this.depositProduct_data.close_date != null) {
			this.depositProduct_data_errors.close_date = false;
		} else {
			this.depositProduct_data_errors.close_date = true;
		}

		if (
			this.depositProduct_data.product_type == 'Life Time' ||
			(this.depositProduct_data.close_date != '' &&
				this.depositProduct_data.close_date != null)
		) {
			this.depositProduct_data_errors.close_date = false;
		} else {
			this.depositProduct_data_errors.close_date = true;
		}

		if (
			this.depositProduct_data.type != '' &&
			this.depositProduct_data.type != null
		) {
			this.depositProduct_data_errors.type = false;
		} else {
			this.depositProduct_data_errors.type = true;
		}


		if (
			this.depositProduct_data.interest_rate != '' &&
			this.depositProduct_data.interest_rate != null
		) {
			this.depositProduct_data_errors.interest_rate = false;
		} else {
			this.depositProduct_data_errors.interest_rate = true;
		}

		if (
			this.depositProduct_data.monthly_fees != '' &&
			this.depositProduct_data.monthly_fees != null
		) {
			this.depositProduct_data_errors.monthly_fees = false;
		} else {
			this.depositProduct_data_errors.monthly_fees = true;
		}

		if (
			this.depositProduct_data.client_product_status != '' &&
			this.depositProduct_data.client_product_status != null
		) {
			this.depositProduct_data_errors.client_product_status = false;
		} else {
			this.depositProduct_data_errors.client_product_status = true;
		}

		// if (this.user_role == "Relationship Manager") {
		// 	if (
		// 		this.depositProduct_data.deposit_purpose != '' &&
		// 		this.depositProduct_data.deposit_purpose != null
		// 	) {
		// 		this.depositProduct_data_errors.deposit_purpose = false;
		// 	} else {
		// 		this.depositProduct_data_errors.deposit_purpose = true;
		// 	}
		// }
		// else {
		// 	this.depositProduct_data.deposit_purpose = "";
		// 	this.depositProduct_data_errors.deposit_purpose = false;
		// }

		if (
			this.depositProduct_data_errors.policy_number == false &&
			this.depositProduct_data_errors.aum == false &&
			this.depositProduct_data_errors.start_date == false &&
			this.depositProduct_data_errors.product == false &&
			this.depositProduct_data_errors.close_date == false &&
			this.depositProduct_data_errors.type == false &&
			this.depositProduct_data_errors.client_product_status == false &&
			this.depositProduct_data_errors.interest_rate == false &&
			this.depositProduct_data_errors.monthly_fees == false &&
			this.min_amount_error == false
			// this.depositProduct_data_errors.deposit_purpose == false
		) {
			return true;
		} else {
			return false;
		}
	}

  lending_product_data: any = {
		client_id: '',
		client_type: '',
		expected_aum: '',
		expected_closure_date: '',
		status: '',
		policy_number: '',
		aum: '',
		start_date: '',
		product: '',
		close_date: '',
		type: '',
		client_product_status: '',
		deposit_purpose: '',
		interest_rate: '',
		monthly_fees: '',

	};
	lending_product_data_errors: any = {
		client_id: '',
		client_type: '',
		expected_aum: '',
		expected_closure_date: '',
		status: '',
		policy_number: '',
		aum: '',
		start_date: '',
		product: '',
		close_date: '',
		type: '',
		client_product_status: '',
		deposit_purpose: '',
		interest_rate: '',
		monthly_fees: '',
	};

	lending_product_data_operation_type: any = "Add";
	validateLendingProductInformation() {
		if (
			this.lending_product_data.policy_number != '' &&
			this.lending_product_data.policy_number != null
		) {
			this.lending_product_data_errors.policy_number = false;
		} else {
			this.lending_product_data_errors.policy_number = true;
		}

		if (
			this.lending_product_data.aum != '' &&
			this.lending_product_data.aum != null
		) {
			this.lending_product_data_errors.aum = false;
		} else {
			this.lending_product_data_errors.aum = true;
		}

		if (
			this.lending_product_data.start_date != '' &&
			this.lending_product_data.start_date != null
		) {
			this.lending_product_data_errors.start_date = false;
		} else {
			this.lending_product_data_errors.start_date = true;
		}

		if (
			this.lending_product_data.product != '' &&
			this.lending_product_data.product != null
		) {
			this.lending_product_data_errors.product = false;
		} else {
			this.lending_product_data_errors.product = true;
		}

		if (this.lending_product_data.close_date != "" && this.lending_product_data.close_date != null) {
			this.lending_product_data_errors.close_date = false;
		} else {
			this.lending_product_data_errors.close_date = true;
		}

		if (
			this.lending_product_data.product_type == 'Life Time' ||
			(this.lending_product_data.close_date != '' &&
				this.lending_product_data.close_date != null)
		) {
			this.lending_product_data_errors.close_date = false;
		} else {
			this.lending_product_data_errors.close_date = true;
		}

		if (
			this.lending_product_data.type != '' &&
			this.lending_product_data.type != null
		) {
			this.lending_product_data_errors.type = false;
		} else {
			this.lending_product_data_errors.type = true;
		}


		if (
			this.lending_product_data.interest_rate != '' &&
			this.lending_product_data.interest_rate != null
		) {
			this.lending_product_data_errors.interest_rate = false;
		} else {
			this.lending_product_data_errors.interest_rate = true;
		}

		if (
			this.lending_product_data.monthly_fees != '' &&
			this.lending_product_data.monthly_fees != null
		) {
			this.lending_product_data_errors.monthly_fees = false;
		} else {
			this.lending_product_data_errors.monthly_fees = true;
		}

		if (
			this.lending_product_data.client_product_status != '' &&
			this.lending_product_data.client_product_status != null
		) {
			this.lending_product_data_errors.client_product_status = false;
		} else {
			this.lending_product_data_errors.client_product_status = true;
		}

		// if (this.user_role == "Relationship Manager") {
		// 	if (
		// 		this.lending_product_data.deposit_purpose != '' &&
		// 		this.lending_product_data.deposit_purpose != null
		// 	) {
		// 		this.lending_product_data_errors.deposit_purpose = false;
		// 	} else {
		// 		this.lending_product_data_errors.deposit_purpose = true;
		// 	}
		// }
		// else {
		// 	this.lending_product_data.deposit_purpose = "";
		// 	this.lending_product_data_errors.deposit_purpose = false;
		// }

		if (
			this.lending_product_data_errors.policy_number == false &&
			this.lending_product_data_errors.aum == false &&
			this.lending_product_data_errors.start_date == false &&
			this.lending_product_data_errors.product == false &&
			this.lending_product_data_errors.close_date == false &&
			this.lending_product_data_errors.type == false &&
			this.lending_product_data_errors.client_product_status == false &&
			this.lending_product_data_errors.interest_rate == false &&
			this.lending_product_data_errors.monthly_fees == false &&
			this.min_amount_error == false
			// this.lending_product_data_errors.deposit_purpose == false
		) {
			return true;
		} else {
			return false;
		}
	}

  insurance_product_data: any = {
		client_id: '',
		client_type: '',
		expected_aum: '',
		expected_closure_date: '',
		status: '',
		policy_number: '',
		aum: '',
		start_date: '',
		product: '',
		close_date: '',
		type: '',
		client_product_status: '',
		deposit_purpose: '',
		interest_rate: '',
		monthly_fees: '',

	};
	insurance_product_data_errors: any = {
		client_id: '',
		client_type: '',
		expected_aum: '',
		expected_closure_date: '',
		status: '',
		policy_number: '',
		aum: '',
		start_date: '',
		product: '',
		close_date: '',
		type: '',
		client_product_status: '',
		deposit_purpose: '',
		interest_rate: '',
		monthly_fees: '',
	};

	insurance_product_data_operation_type: any = "Add";
	validateInsuranceProductInformation() {
		if (
			this.insurance_product_data.policy_number != '' &&
			this.insurance_product_data.policy_number != null
		) {
			this.insurance_product_data_errors.policy_number = false;
		} else {
			this.insurance_product_data_errors.policy_number = true;
		}

		if (
			this.insurance_product_data.aum != '' &&
			this.insurance_product_data.aum != null
		) {
			this.insurance_product_data_errors.aum = false;
		} else {
			this.insurance_product_data_errors.aum = true;
		}

		if (
			this.insurance_product_data.start_date != '' &&
			this.insurance_product_data.start_date != null
		) {
			this.insurance_product_data_errors.start_date = false;
		} else {
			this.insurance_product_data_errors.start_date = true;
		}

		if (
			this.insurance_product_data.product != '' &&
			this.insurance_product_data.product != null
		) {
			this.insurance_product_data_errors.product = false;
		} else {
			this.insurance_product_data_errors.product = true;
		}

		if (this.insurance_product_data.close_date != "" && this.insurance_product_data.close_date != null) {
			this.insurance_product_data_errors.close_date = false;
		} else {
			this.insurance_product_data_errors.close_date = true;
		}

		if (
			this.insurance_product_data.product_type == 'Life Time' ||
			(this.insurance_product_data.close_date != '' &&
				this.insurance_product_data.close_date != null)
		) {
			this.insurance_product_data_errors.close_date = false;
		} else {
			this.insurance_product_data_errors.close_date = true;
		}

		if (
			this.insurance_product_data.type != '' &&
			this.insurance_product_data.type != null
		) {
			this.insurance_product_data_errors.type = false;
		} else {
			this.insurance_product_data_errors.type = true;
		}


		if (
			this.insurance_product_data.interest_rate != '' &&
			this.insurance_product_data.interest_rate != null
		) {
			this.insurance_product_data_errors.interest_rate = false;
		} else {
			this.insurance_product_data_errors.interest_rate = true;
		}

		if (
			this.insurance_product_data.monthly_fees != '' &&
			this.insurance_product_data.monthly_fees != null
		) {
			this.insurance_product_data_errors.monthly_fees = false;
		} else {
			this.insurance_product_data_errors.monthly_fees = true;
		}

		if (
			this.insurance_product_data.client_product_status != '' &&
			this.insurance_product_data.client_product_status != null
		) {
			this.insurance_product_data_errors.client_product_status = false;
		} else {
			this.insurance_product_data_errors.client_product_status = true;
		}

		// if (this.user_role == "Relationship Manager") {
		// 	if (
		// 		this.insurance_product_data.deposit_purpose != '' &&
		// 		this.insurance_product_data.deposit_purpose != null
		// 	) {
		// 		this.insurance_product_data_errors.deposit_purpose = false;
		// 	} else {
		// 		this.insurance_product_data_errors.deposit_purpose = true;
		// 	}
		// }
		// else {
		// 	this.insurance_product_data.deposit_purpose = "";
		// 	this.insurance_product_data_errors.deposit_purpose = false;
		// }

		if (
			this.insurance_product_data_errors.policy_number == false &&
			this.insurance_product_data_errors.aum == false &&
			this.insurance_product_data_errors.start_date == false &&
			this.insurance_product_data_errors.product == false &&
			this.insurance_product_data_errors.close_date == false &&
			this.insurance_product_data_errors.type == false &&
			this.insurance_product_data_errors.client_product_status == false &&
			this.insurance_product_data_errors.interest_rate == false &&
			this.insurance_product_data_errors.monthly_fees == false &&
			this.min_amount_error == false
			// this.insurance_product_data_errors.deposit_purpose == false
		) {
			return true;
		} else {
			return false;
		}
	}


	closeDepostClientDealModal() {
		this.conversion_status_data = {
			conversion_status: '',
			conversion_comments: '',
		};
		this.conversion_status_data_errors = {
			conversion_status: false,
			conversion_comments: false,
		};
		this.depositProduct_data = {
			client_id: '',
			client_type: '',
			expected_aum: '',
			expected_closure_date: '',
			status: '',
			policy_number: '',
			aum: '',
			start_date: '',
			product: '',
			close_date: '',
			type: '',
			client_product_status: '',
			deposit_purpose: '',
			interest_rate: '',
			monthly_fees: '',

		};
		this.depositProduct_data_errors = {
			client_id: '',
			client_type: '',
			expected_aum: '',
			expected_closure_date: '',
			status: '',
			policy_number: '',
			aum: '',
			start_date: '',
			product: '',
			close_date: '',
			type: '',
			client_product_status: '',
			deposit_purpose: '',
			interest_rate: '',
			monthly_fees: '',
		};
		this.depositProduct_operation_type = "Add";

    this.lending_product_data = {
			client_id: '',
			client_type: '',
			expected_aum: '',
			expected_closure_date: '',
			status: '',
			policy_number: '',
			aum: '',
			start_date: '',
			product: '',
			close_date: '',
			type: '',
			client_product_status: '',
			deposit_purpose: '',
			interest_rate: '',
			monthly_fees: '',

		};
		this.lending_product_data_errors = {
			client_id: '',
			client_type: '',
			expected_aum: '',
			expected_closure_date: '',
			status: '',
			policy_number: '',
			aum: '',
			start_date: '',
			product: '',
			close_date: '',
			type: '',
			client_product_status: '',
			deposit_purpose: '',
			interest_rate: '',
			monthly_fees: '',
		};
		this.lending_product_data_operation_type = "Add";

    this.insurance_product_data = {
			client_id: '',
			client_type: '',
			expected_aum: '',
			expected_closure_date: '',
			status: '',
			policy_number: '',
			aum: '',
			start_date: '',
			product: '',
			close_date: '',
			type: '',
			client_product_status: '',
			deposit_purpose: '',
			interest_rate: '',
			monthly_fees: '',

		};
		this.insurance_product_data_errors = {
			client_id: '',
			client_type: '',
			expected_aum: '',
			expected_closure_date: '',
			status: '',
			policy_number: '',
			aum: '',
			start_date: '',
			product: '',
			close_date: '',
			type: '',
			client_product_status: '',
			deposit_purpose: '',
			interest_rate: '',
			monthly_fees: '',
		};
		this.insurance_product_data_operation_type = "Add";

		this.outcome_data = {
			attrition_status: '',
			attrition_comments: '',
		};
		this.outcome_data_errors = {
			attrition_status: false,
			attrition_comments: false,
		};
	}




	closeDealInformation() {
		if (
			this.conversion_status_data.conversion_status != '' &&
			this.conversion_status_data.conversion_status != null
		) {
			this.conversion_status_data_errors.conversion_status = false;
		} else {
			this.conversion_status_data_errors.conversion_status = true;
		}

		if (
			this.conversion_status_data.conversion_comments != '' &&
			this.conversion_status_data.conversion_comments != null
		) {
			this.conversion_status_data_errors.conversion_comments = false;
		} else {
			this.conversion_status_data_errors.conversion_comments = true;
		}

		if (
			this.conversion_status_data_errors.conversion_status == false &&
			this.conversion_status_data_errors.conversion_comments == false
		) {
			if (this.conversion_status_data.conversion_status == 1 && this.selected_table_data.length == 1) {
				// if (this.validateProductInformation()) {
				// 	this.saveCloseDealInformation();
				// }
				if (this.user_details.role.business_area[0] == '5') {
					if (this.validateProductInformation()) {
						this.saveCloseDealInformation();
					}
				}
				if (this.user_details.role.business_area[0] == '6') {
					if (this.validateDepositProductInformation()) {
						this.saveCloseDealInformation();
					}
				}

        if (this.user_details.role.business_area[0] == '7') {
					if (this.validateLendingProductInformation()) {
						this.saveCloseDealInformation();
					}
				}

        if (this.user_details.role.business_area[0] == '8') {
					if (this.validateInsuranceProductInformation()) {
						this.saveCloseDealInformation();
					}
				}

			} else {
				if (this.conversion_status_data.conversion_status != 1) {
					this.saveCloseDealInformation();
				}
			}
		}
	}

	saveCloseDealInformation() {
		let payload: any;
		if (this.user_details.role.business_area[0] == '5') {
		payload = {
			client_list: [],
			stepper_type: "",
			conversion_status_id: this.conversion_status_data.conversion_status,
			conversion_comments: this.conversion_status_data.conversion_comments,
			not_required: this.move_record_stage_activity_status,
		};
	}
	if (this.user_details.role.business_area[0] == '6') {
		payload = {
			product: this.depositProduct_data.product,
			policy_number: this.depositProduct_data.policy_number,
			aum: this.depositProduct_data.aum == '' ? 0 : this.depositProduct_data.aum,
			start_date: moment(this.depositProduct_data.start_date).format(),
			close_date: this.depositProduct_data.close_date != '' ? moment(this.depositProduct_data.close_date).format() : null,
			// client: this.selected_user_data.id,
			// client: this.activities[this.show_inner_view].client,
			type: this.depositProduct_data.type,
			deposit_purpose: this.depositProduct_data.deposit_purpose,
			interest_rate: this.depositProduct_data.interest_rate,
			monthly_fees: this.depositProduct_data.monthly_fees,
			conversion_status_id: this.conversion_status_data.conversion_status,
			conversion_comments: this.conversion_status_data.conversion_comments,
			client_list: [],
			stepper_type: "",
		};
	}

  if (this.user_details.role.business_area[0] == '7') {
		payload = {
			product: this.depositProduct_data.product,
			policy_number: this.depositProduct_data.policy_number,
			aum: this.depositProduct_data.aum == '' ? 0 : this.depositProduct_data.aum,
			start_date: moment(this.depositProduct_data.start_date).format(),
			close_date: this.depositProduct_data.close_date != '' ? moment(this.depositProduct_data.close_date).format() : null,
			// client: this.selected_user_data.id,
			// client: this.activities[this.show_inner_view].client,
			type: this.depositProduct_data.type,
			deposit_purpose: this.depositProduct_data.deposit_purpose,
			interest_rate: this.depositProduct_data.interest_rate,
			monthly_fees: this.depositProduct_data.monthly_fees,
			conversion_status_id: this.conversion_status_data.conversion_status,
			conversion_comments: this.conversion_status_data.conversion_comments,
			client_list: [],
			stepper_type: "",
		};
	}

  if (this.user_details.role.business_area[0] == '8') {
		payload = {
			product: this.depositProduct_data.product,
			policy_number: this.depositProduct_data.policy_number,
			aum: this.depositProduct_data.aum == '' ? 0 : this.depositProduct_data.aum,
			start_date: moment(this.depositProduct_data.start_date).format(),
			close_date: this.depositProduct_data.close_date != '' ? moment(this.depositProduct_data.close_date).format() : null,
			// client: this.selected_user_data.id,
			// client: this.activities[this.show_inner_view].client,
			type: this.depositProduct_data.type,
			deposit_purpose: this.depositProduct_data.deposit_purpose,
			interest_rate: this.depositProduct_data.interest_rate,
			monthly_fees: this.depositProduct_data.monthly_fees,
			conversion_status_id: this.conversion_status_data.conversion_status,
			conversion_comments: this.conversion_status_data.conversion_comments,
			client_list: [],
			stepper_type: "",
		};
	}

		if (this.type == "Upside Opportunities") {
			payload.stepper_type = "opportunity";
		} else if (this.type == "Retention Opportunities") {
			payload.stepper_type = "retention";
		// } else if (this.type == "Institutional Customers to Investment Clients") {
		} else if (this.type == "Bank Customers to Investment Clients") {
			// payload.stepper_type = "members";
			payload.stepper_type = "new";
		// } else if (this.type == "Institutional Customers to Deposit Clients") {
		} else if (this.type == "Bank Customers to Deposit Clients") {
			payload.stepper_type = "new";
		} else if (this.type == "Bank Customers to Lending Clients") {
			payload.stepper_type = "new";
		} else if (this.type == "Bank Customers to Insurance Clients") {
			payload.stepper_type = "new";
		} else if (this.type == "Non Customers") {
			// payload.stepper_type = "non_members";
			payload.stepper_type = "new";
		}

		for (let index = 0; index < this.selected_table_data.length; index++) {
			payload.client_list.push(this.selected_table_data[index].id);
		}

		if (this.conversion_status_data.conversion_status == 1 && this.selected_table_data.length == 1) {
			if(this.user_details.role.business_area[0] == 5){
				payload.product = this.product_data.product;
				payload.policy_number = this.product_data.policy_number;
				payload.aum = this.product_data.aum == '' ? 0 : this.product_data.aum;
				payload.start_date = moment(this.product_data.start_date).format();
				payload.close_date = this.product_data.close_date != '' ? moment(this.product_data.close_date).format() : null;
				payload.type = this.product_data.type;
				payload.deposit_purpose = this.product_data.deposit_purpose;
			}

		}

		this.commonService.postData("/closedeal/", payload).subscribe(
			(res: any) => {
				this.closeClientDealModal();
				this.closeDepostClientDealModal();
				this.selected_table_data = [];
				this.is_selected = false;
				this.current_pagination_page = 1;
				this.changeStepper();
				this.getPageSummary();
				this.commonService.showToast('success', 'Client moved to result stage; activities no longer visible upon deal closer',);
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	@ViewChild('changeOutcomeModal') changeOutcomeModal: TemplateRef<any>;
	private changeOutcomeModalRef: MatDialogRef<TemplateRef<any>>;
	// openChangeOutcomeModal() {
	// 	if (this.selected_table_data.length > 0) {
	// 		this.changeOutcomeModalRef = this.dialog.open(this.changeOutcomeModal, { disableClose: true });
	// 		this.changeOutcomeModalRef.afterClosed().subscribe((result) => {
	// 			this.closeChangeOucomeModal();
	// 		});
	// 		this.move_record_error = false;
	// 	} else {
	// 		this.move_record_error = true;
	// 	}
	// }

	openChangeOutcomeModal(client) {
		this.selected_table_data = [];
		this.selected_table_data.push(client);
		this.changeOutcomeModalRef = this.dialog.open(this.changeOutcomeModal, { disableClose: true });
		this.changeOutcomeModalRef.afterClosed().subscribe((result) => {
			this.closeChangeOucomeModal();
		});
	}

	closeChangeOucomeModal() {
		this.changeOutcomeModalRef.close();
		this.move_record_error = false;
		this.move_record_stage_activity_status = false;
		this.outcome_data = {
			attrition_status: '',
			attrition_comments: '',
		};
		this.outcome_data_errors = {
			attrition_status: false,
			attrition_comments: false,
		};
		this.product_data = {
			client_id: '',
			client_type: '',
			expected_aum: '',
			expected_closure_date: '',
			status: '',
			policy_number: '',
			aum: '',
			start_date: '',
			product: '',
			close_date: '',
			type: '',
			client_product_status: '',
			deposit_purpose: '',
		};
		this.product_data_errors = {
			client_id: false,
			client_type: false,
			expected_aum: false,
			expected_closure_date: false,
			status: false,
			policy_number: false,
			aum: false,
			start_date: false,
			product: false,
			close_date: false,
			type: false,
			client_product_status: false,
			deposit_purpose: false,
		};
		this.product_operation_type = "Add";
	}

	outcome_data: any = {
		attrition_status: '',
		attrition_comments: '',
	};
	outcome_data_errors: any = {
		attrition_status: false,
		attrition_comments: false,
	};
	changeOutcome() {
		if (
			this.outcome_data.attrition_status != '' &&
			this.outcome_data.attrition_status != null
		) {
			this.outcome_data_errors.attrition_status = false;
		} else {
			this.outcome_data_errors.attrition_status = true;
		}

		if (
			this.outcome_data.attrition_comments != '' &&
			this.outcome_data.attrition_comments != null
		) {
			this.outcome_data_errors.attrition_comments = false;
		} else {
			this.outcome_data_errors.attrition_comments = true;
		}

		if (
			this.outcome_data_errors.attrition_status == false &&
			this.outcome_data_errors.attrition_comments == false
		) {
			if (this.outcome_data.attrition_status == 'Retained, Upside' && this.selected_table_data.length == 1) {
				// if (this.validateProductInformation()) {
				// 	this.saveOutcomeInformation();
				// }
				if (this.user_details.role.business_area[0] == '5') {
					if (this.validateProductInformation()) {
						this.saveOutcomeInformation();
					}
				}
				if (this.user_details.role.business_area[0] == '6') {
					if (this.validateDepositProductInformation()) {
						this.saveOutcomeInformation();
					}
				}

        if (this.user_details.role.business_area[0] == '7') {
					if (this.validateLendingProductInformation()) {
						this.saveOutcomeInformation();
					}
				}

        if (this.user_details.role.business_area[0] == '8') {
					if (this.validateInsuranceProductInformation()) {
						this.saveOutcomeInformation();
					}
				}
			} else {
				if (this.outcome_data.attrition_status != 'Retained, Upside') {
					this.saveOutcomeInformation();
				}
			}
		}
	}

	saveOutcomeInformation() {
		let payload: any = {
			client_list: [],
			stepper_type: "",
			attrition_status: this.outcome_data.attrition_status,
			attrition_comments: this.outcome_data.attrition_comments,
			not_required: this.move_record_stage_activity_status,
		};

		if (this.type == "Upside Opportunities") {
			payload.stepper_type = "opportunity";
		} else if (this.type == "Retention Opportunities") {
			payload.stepper_type = "retention";
		// } else if (this.type == "Institutional Customers to Investment Clients") {
		} else if (this.type == "Bank Customers to Investment Clients") {
			payload.stepper_type = "new";
		// } else if (this.type == "Institutional Customers to Deposit Clients") {
		} else if (this.type == "Bank Customers to Deposit Clients") {
			// payload.stepper_type = "members";
			payload.stepper_type = "new";
		} else if (this.type == "Non Customers") {
			// payload.stepper_type = "non_members";
			payload.stepper_type = "new";
		}

		for (let index = 0; index < this.selected_table_data.length; index++) {
			payload.client_list.push(this.selected_table_data[index].id);
		}

		if (this.outcome_data.attrition_status == 'Retained, Upside' && this.selected_table_data.length == 1) {
			payload.product = this.product_data.product;
			payload.policy_number = this.product_data.policy_number;
			payload.aum = this.product_data.aum == '' ? 0 : this.product_data.aum;
			payload.start_date = moment(this.product_data.start_date).format();
			payload.close_date = this.product_data.close_date != '' ? moment(this.product_data.close_date).format() : null;
			payload.type = this.product_data.type;
			payload.deposit_purpose = this.product_data.deposit_purpose;
		}

		this.commonService.postData("/changeoutcome/", payload).subscribe(
			(res: any) => {
				this.closeChangeOucomeModal();
				this.selected_table_data = [];
				this.is_selected = false;
				this.current_pagination_page = 1;
				this.changeStepper();
				this.getPageSummary();
				this.commonService.showToast('success', 'Client moved to result stage; activities no longer visible upon deal closer',);
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}


	@ViewChild('clientDataModal') clientDataModal: TemplateRef<any>;
	private clientDataModalRef: MatDialogRef<TemplateRef<any>>;

	selected_modal_user: any;
	selected_modal_user_type: any;
	selected_modal_user_loader: boolean = false;;
	openClientDataModal(data) {
		this.selected_modal_user_loader = true;
		this.selected_modal_user = JSON.parse(JSON.stringify(data));

		this.clientDataModalRef = this.dialog.open(this.clientDataModal, { disableClose: true });
		this.clientDataModalRef.afterClosed().subscribe((result) => {
			this.closeClientDataModal();
		});

		let route: any = "";

		if (this.type == "Upside Opportunities") {
			this.selected_modal_user_type = "Client";
			route = "/customerdetails/?id=" + this.selected_modal_user.id;
		} else if (this.type == "Retention Opportunities") {
			this.selected_modal_user_type = "Client";
			route = "/customerdetails/?id=" + this.selected_modal_user.id;
		// } else if (this.type == "Institutional Customers to Investment Clients") {
		} else if (this.type == "Bank Customers to Investment Clients") {
			this.selected_modal_user_type = "Lead";
			route = "/prospectdetails/?id=" + this.selected_modal_user.id;
		// } else if (this.type == "Institutional Customers to Deposit Clients") {
		} else if (this.type == "Bank Customers to Deposit Clients") {
			this.selected_modal_user_type = "Lead";
			route = "/prospectdetails/?id=" + this.selected_modal_user.id;
		} else if (this.type == "Non Customers") {
			this.selected_modal_user_type = "Lead";
			route = "/prospectdetails/?id=" + this.selected_modal_user.id;
		}

		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.selected_modal_user = res["data"];
				this.selected_modal_user_loader = false;
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	closeClientDataModal() {
		this.clientDataModalRef.close();
		this.selected_modal_user = {};
		this.selected_modal_user_type = "";
		this.selected_modal_user_loader = false;
	}

	numberOnly(event): boolean {
		const charCode = event.which ? event.which : event.keyCode;
		if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
		  return false;
		}
	}


	opportunity_client: any;
  	@ViewChild('addOpportunityModal') addOpportunityModal: TemplateRef<any>;
	private addOpportunityModalRef: MatDialogRef<TemplateRef<any>>;
	openAddOpportunityModal(data) {
		this.opportunity_client = JSON.parse(JSON.stringify(data));
		this.addOpportunityModalRef = this.dialog.open(
			this.addOpportunityModal, { disableClose: true }
		);
		this.addOpportunityModalRef.afterClosed().subscribe((result) => {
			this.closeAddOpportunityModal();
		});
	}

	closeAddOpportunityModal() {
		this.addOpportunityModalRef.close();
		this.opportunity_client = {};
	}

	addOpportunity() {
		const payload = {
			id: this.opportunity_client.id
		};
		this.commonService.postData("/converttoopportunity/", payload).subscribe(
			(res: any) => {
				this.commonService.showToast('success', 'Added to Opportunities Successfully.');
				this.getPageSummary();
				this.closeAddOpportunityModal();
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
	}

	ai_explainability_sections: any = [];

	upside_opportunity_ai_explainability_sections: any = [
		{
			name: "",
			sub_sections: [
				{
					name: "AI Rank",
					value: "Upside Opportunity is a crucial metric that helps identify the most promising clients for the company. This is a significant factor in the company's strategy for expanding its services. This rank is calculated by employing a sophisticated combination of two AI models: predicted opportunity and the shortest time to close the deal by the advisor. This AI model considers various client-specific attributes, historical transactions, advisor attributes, and macroeconomic variables. By analyzing these data points, the AI model can accurately assess the likelihood of a client churning."
				},
				{
					name: "AI recommendation",
					value: "Two additional AI models work in parallel to identify the optimal products and channels for the clients. These AI models help the advisor to recommend products through preferred channels. The AI model considers various client-specific attributes and historical transactions. By analyzing these data points, the AI model can accurately assess the optimal products and channels."
				},
				{
					name: "Opportunity",
					value: "The objective of this model is to predict the advisor's likelihood to sell. The input variables are demographic variables (client) and macroeconomic variables (market performance). This model works for existing clients as well as new clients (prospects). For the new clients the AUM, Balance, Net worth, Liquid net worth, and Count of products are not captured. These variables are not part of the final model. "
				},
				{
					name: "Shortest time to close",
					value: "This model estimates the shortest time to close the deal. Inputs to the model include customer demographics, transaction history, total investment, advisor experience, advisor certificates & licenses, and advisor states serviced. Relationships are identified between the independent and dependent variables using AI models. The model returns the days it takes to close the deal. "
				},
				{
					name: "Channel and Product",
					value: "Two additional AI models work in parallel to identify the optimal products and channels for the clients. These AI models help the advisor to recommend products through preferred channels. The AI model considers various client-specific attributes and historical transactions. "
				}
			]
		},
	];

	retention_opportunity_ai_explainability_sections: any = [
		{
			name: "",
			sub_sections: [
				{
					name: "Risk Rank",
					value: "Attrition is a critical aspect of client management, and it involves a synergistic approach that combines both business rules and an advanced AI model. Together, these components collaboratively generate the risk rank for each client. Initially, the rule-based engine identifies clients who might be at risk of attrition based on predefined criteria and business rules."
				},
				{
					name: "Attrition Prediction",
					value: "After the rule-based engine identifies the at-risk clients, an AI model comes into play to calculate the probability of attrition for each identified client. The AI model considers various client-specific attributes and historical transactions. By analyzing these data points, the AI model can accurately assess the likelihood of a client churning."
				},
				{
					name: "Opportunity",
					value: "The objective of this model is to predict the advisor's likelihood to sell. The input variables are demographic variables (client) and macroeconomic variables (market performance). This model works for existing clients as well as new clients (prospects). For the new clients the AUM, Balance, Net worth, Liquid net worth, and Count of products are not captured. These variables are not part of the final model. "
				},
				{
					name: "Total Estimated Loss",
					value: "To understand the potential impact of attrition, the total estimated loss is calculated. This estimate is derived by summing up two key components: upside opportunities and the total value of invested aum. Upside opportunities involve identifying additional products or services that can be offered to existing clients. "
				}
			]
		},
	];

	leads_ai_explainability_sections: any = [
		{
			name: "",
			sub_sections: [
				{
					name: "Opportunity",
					value: "New opportunity is a crucial metric that helps identify the most promising targets for the company. This is a significant factor in the company's strategy for expanding its services. This rank is calculated by employing a sophisticated combination of two AI models: AI rank and predicted wallet share"
				},
				{
					name: "AI Rank",
					value: "AI model comes into play to calculate the probability of successful sales for each identified target. The AI model considers various target-specific attributes, advisor attributes, and macroeconomic variables. By analyzing these data points, the AI model can accurately assess the likelihood of closing a deal."
				},
				{
					name: "Predicted Wallet Share",
					value: "This valuable metric is used to forecast the potential growth in the prospect's wallet share. It is calculated by utilizing the insights provided by the predicted opportunity along with the net worth of the prospect. This information aids the company in making data-driven decisions regarding resource allocation, targeted marketing strategies, and personalized offerings to enhance the prospect's overall engagement and satisfaction."
				}
			]
		},
	];

	deposit_ai_explainability_sections: any = [
		{
			name: "",
			sub_sections: [
				{
					name: "Opportunity",
					value: "New opportunity is a crucial metric that helps identify the most promising targets for the company. This is a significant factor in the company's strategy for expanding its services. This rank is calculated by employing a sophisticated combination of two AI models: AI rank and predicted wallet share"
				},
				{
					name: "AI Rank",
					value: "AI model comes into play to calculate the probability of successful sales for each identified target. The AI model considers various target-specific attributes, advisor attributes, and macroeconomic variables. By analyzing these data points, the AI model can accurately assess the likelihood of closing a deal."
				},
				{
					name: "Predicted Wallet Share",
					value: "This valuable metric is used to forecast the potential growth in the prospect's wallet share. It is calculated by utilizing the insights provided by the predicted opportunity along with the net worth of the prospect. This information aids the company in making data-driven decisions regarding resource allocation, targeted marketing strategies, and personalized offerings to enhance the prospect's overall engagement and satisfaction."
				}
			]
		},
	];

	non_customer_ai_explainability_sections: any = [
		{
			name: "",
			sub_sections: [
				{
					name: "Opportunity",
					value: "New opportunity is a crucial metric that helps identify the most promising targets for the company. This is a significant factor in the company's strategy for expanding its services. This rank is calculated by employing a sophisticated combination of two AI models: AI rank and predicted wallet share"
				},
				{
					name: "AI Rank",
					value: "AI model comes into play to calculate the probability of successful sales for each identified target. The AI model considers various target-specific attributes, advisor attributes, and macroeconomic variables. By analyzing these data points, the AI model can accurately assess the likelihood of closing a deal."
				},
				{
					name: "Predicted Wallet Share",
					value: "This valuable metric is used to forecast the potential growth in the prospect's wallet share. It is calculated by utilizing the insights provided by the predicted opportunity along with the net worth of the prospect. This information aids the company in making data-driven decisions regarding resource allocation, targeted marketing strategies, and personalized offerings to enhance the prospect's overall engagement and satisfaction."
				}
			]
		},
	];

  lending_ai_explainability_sections: any = [
		{
			// name: "The Institutional Customers to Deposit Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
			name: "The Bank Customers to Lending Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
			sub_sections: [
				// {
				// 	name: "Purpose of the 'Institutional Customers to Deposit Clients Section",
				// 	value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Institutional Customers to Deposit Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
				// },
				{
					name: "Purpose of the Bank Customers to Lending Clients Section",
					value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Bank Customers to Deposit Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
				},
				{
					name: "Leveraging Existing Relationships",
					value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
				},
				{
					name: "Addressing Industry Gaps",
					value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
				},
				{
					name: "Integration with Traditional Methods",
					value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
				},
				{
					name: "Transforming Banking Clients into Investment Clients",
					value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
				},
				{
					name: "Strategic Advantage",
					// value: "The 'Institutional Customers to Deposit Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
					value: "The 'Bank Customers to Lending Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
				},
			]
		},
	];

  insurance_ai_explainability_sections: any = [
		{
			// name: "The Institutional Customers to Deposit Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
			name: "The Bank Customers to Insurance Clients section is crafted to enhance the efficiency of the lead generation and conversion process:",
			sub_sections: [
				// {
				// 	name: "Purpose of the 'Institutional Customers to Deposit Clients Section",
				// 	value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Institutional Customers to Deposit Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
				// },
				{
					name: "Purpose of the Bank Customers to Insurance Clients Section",
					value: "The core purpose of this section is to streamline the identification, engagement, and conversion of Bank Customers to Deposit Clients into active clients. It is designed to move beyond conventional lead acquisition methods by harnessing the power of existing client relationships across the organization's diverse product offerings."
				},
				{
					name: "Leveraging Existing Relationships",
					value: "Advisors can tap into the organization's broad client base, which may include customers of banks and credit unions who utilize services like credit cards, savings accounts, and auto loans. The goal is to pinpoint those within this vast customer pool who may have latent investment needs."
				},
				{
					name: "Addressing Industry Gaps",
					value: "Wealth management sectors often face the challenge of recognizing banking customers who could potentially be interested in investment opportunities. Given the sheer volume of customers, identifying and prioritizing those with investment potential has been a significant hurdle. This section is strategically developed to close this gap, providing tools and analytics to highlight promising prospects among banking clients."
				},
				{
					name: "Integration with Traditional Methods",
					value: "In addition to utilizing internal cross-sell opportunities, this section also incorporates leads generated through traditional channels such as referrals. It serves as a comprehensive repository for all potential leads, irrespective of their source."
				},
				{
					name: "Transforming Banking Clients into Investment Clients",
					value: "The section is not only about lead capture but also about effective conversion, aiming to transform single-service users into multi-faceted clients who engage with both banking and investment services. This dual engagement strategy is aimed at fostering deeper client relationships and enhancing the client's financial experience with the organization."
				},
				{
					name: "Strategic Advantage",
					// value: "The 'Institutional Customers to Deposit Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
					value: "The 'Bank Customers to Insurance Clients section provides a strategic advantage by offering a consolidated view of potential leads. It empowers advisors with the necessary insights and tools to effectively target and convert high-potential banking customers into investment clients, thereby expanding the client base and driving growth for both the advisors and the organization."
				},
			]
		},
	];




show_user_profile: boolean = false;
user_profile_data: any;
user_profile_data_type: any = "";
showUserProfile(data) {
  if (this.type == "Upside Opportunities") {
    this.user_profile_data_type = "Client";
  } else if (this.type == "Retention Opportunities") {
    this.user_profile_data_type = "Client";
  // } else if (this.type == "Institutional Customers to Investment Clients") {
  } else if (this.type == "Bank Customers to Investment Clients") {
    this.user_profile_data_type = "Lead";
  // } else if (this.type == "Institutional Customers to Deposit Clients") {
  } else if (this.type == "Bank Customers to Deposit Clients") {
    this.user_profile_data_type = "Lead";
  } else if (this.type == "Bank Customers to Lending Clients") {
    this.user_profile_data_type = "Lead";
  } else if (this.type == "Bank Customers to Insurance Clients") {
    this.user_profile_data_type = "Lead";
  } else if (this.type == "Non Customers") {
    this.user_profile_data_type = "Lead";
  } else if (this.type == "New Prospects") {
      this.user_profile_data_type = "Lead";
  } else if (this.type == "Upside Opportunities MAGI") {
    this.user_profile_data_type = "Client";
  } else if (this.type == "Retention Opportunities MAGI") {
    this.user_profile_data_type = "Client";
  } else if (this.type == "Bank Customers to Investment Clients MAGI") {
    this.user_profile_data_type = "Lead";
  } else if (this.type == "Bank Customers to Deposit Clients MAGI") {
    this.user_profile_data_type = "Lead";
  } else if (this.type == "Non Customers MAGI") {
    this.user_profile_data_type = "Lead";
  } else if (this.type == "Marketing Team Bank Customers to Investment Clients Unassigned") {
    this.user_profile_data_type = "Lead";
  } else if (this.type == "Marketing Team New Prospects Unassigned") {
    this.user_profile_data_type = "Lead";
  } else if (this.type == "Marketing Team New Prospects - Investments Unassigned") {
    this.user_profile_data_type = "Lead";
  } else if (this.type == "Marketing Team Bank Customers to Deposit Clients Unassigned") {
    this.user_profile_data_type = "Lead";
  } else if (this.type == "Marketing Team Non Customers Unassigned") {
    this.user_profile_data_type = "Lead";
  } else if (this.type == "Marketing Team New Prospects - Deposits Unassigned") {
    this.user_profile_data_type = "Lead";
  } else if (this.type == "Marketing Team Bank Customers to Lending Clients Unassigned") {
    this.user_profile_data_type = "Lead";
  } else if (this.type == "Marketing Team New Prospects - Lending Unassigned") {
    this.user_profile_data_type = "Lead";
  } else if (this.type == "Marketing Team Bank Customers to Insurance Clients Unassigned") {
    this.user_profile_data_type = "Lead";
  } else if (this.type == "Marketing Team New Prospects - Insurance Unassigned") {
    this.user_profile_data_type = "Lead";
  } else if (this.type == "Marketing Team Bank Customers to Investment Clients Assigned") {
    this.user_profile_data_type = "Lead";
  } else if (this.type == "Marketing Team New Prospects Assigned") {
    this.user_profile_data_type = "Lead";
  } else if (this.type == "Marketing Team New Prospects - Investments Assigned") {
    this.user_profile_data_type = "Lead";
  } else if (this.type == "Marketing Team Bank Customers to Deposit Clients Assigned") {
    this.user_profile_data_type = "Lead";
  } else if (this.type == "Marketing Team Non Customers Assigned") {
    this.user_profile_data_type = "Lead";
  } else if (this.type == "Marketing Team New Prospects - Deposits Assigned") {
    this.user_profile_data_type = "Lead";
  } else if (this.type == "Marketing Team Bank Customers to Lending Clients Assigned") {
    this.user_profile_data_type = "Lead";
  } else if (this.type == "Marketing Team New Prospects - Lending Assigned") {
    this.user_profile_data_type = "Lead";
  } else if (this.type == "Marketing Team Bank Customers to Insurance Clients Assigned") {
    this.user_profile_data_type = "Lead";
  } else if (this.type == "Marketing Team New Prospects - Insurance Assigned") {
    this.user_profile_data_type = "Lead";
  }

  // else if (this.type == "Marketing Team Bank Customers to Investment Clients Unassigned") {
  //  this.user_profile_data_type = "Lead";
  // } else if (this.type == "Marketing Team New Prospects Unassigned") {
  //  this.user_profile_data_type = "Lead";
  // } else if (this.type == "Marketing Team Bank Customers to Deposit Clients Unassigned") {
  //  this.user_profile_data_type = "Lead";
  // } else if (this.type == "Marketing Team Non Customers Unassigned") {
  //  this.user_profile_data_type = "Lead";
  // } else if (this.type == "Marketing Team Bank Customers to Investment Clients Assigned") {
  //  this.user_profile_data_type = "Lead";
  // } else if (this.type == "Marketing Team New Prospects Assigned") {
  //  this.user_profile_data_type = "Lead";
  // } else if (this.type == "Marketing Team Bank Customers to Deposit Clients Assigned") {
  //  this.user_profile_data_type = "Lead";
  // } else if (this.type == "Marketing Team Non Customers Assigned") {
  //  this.user_profile_data_type = "Lead";
  // }
  this.user_profile_data = JSON.parse(JSON.stringify(data));
  this.show_user_profile = true;
}


profileClosed(event) {
	this.user_profile_data = {};
	this.show_user_profile = false;
	this.user_profile_data_type = "";
}

	opp_breakdown_id: any = "";
	opp_breakdown_name: any = "";

	rules_breakdown_id: any =  "";
	rules_breakdown_name: any =  "";

	ai_breakdown_id: any =  "";
	ai_breakdown_name: any =  "";

	common_breakdown_id: any =  "";
	common_breakdown_name: any =  "";

	show_analysis: boolean = false;
	analysisChanged(data) {
		if (data.type == "Opportunities") {
			this.opp_breakdown_id = data.id;
			this.opp_breakdown_name = data.name;

			this.current_pagination_page = 1;
			this.getTableData();
		} else if (data.type == "Rule Based Triggers") {
			this.rules_breakdown_id = data.id;
			this.rules_breakdown_name = data.name;

			this.current_pagination_page = 1;
			this.getTableData();
		} else if (data.type == "AI Triggers") {
			this.ai_breakdown_id = data.id;
			this.ai_breakdown_name = data.name;

			this.current_pagination_page = 1;
			this.getTableData();
		} else if (data.type == "Common Triggers") {
			this.common_breakdown_id = data.id;
			this.common_breakdown_name = data.name;

			this.current_pagination_page = 1;
			this.getTableData();
		}
	}


	@ViewChild('syncActivitiesModal') syncActivitiesModal: TemplateRef<any>;
	private syncActivitiesModalRef: MatDialogRef<TemplateRef<any>>;
	openSyncActivitiesModal() {
		this.syncActivitiesModalRef = this.dialog.open(
			this.syncActivitiesModal, { disableClose: true }
		);
		this.syncActivitiesModalRef.afterClosed().subscribe((result) => {
			this.closeSyncActivitiesModal();
		});
	}

	closeSyncActivitiesModal() {
		this.syncActivitiesModalRef.close();
	}

	salesforce_sync_loader: boolean = false;
	salesforceSync(data) {
		this.salesforce_sync_loader = true;
		let route: any = "";

		if (this.type == "Upside Opportunities") {
			route = "/syncsalesforceactivities?client_id=" + data.id + "&user_type=Client&opp_type=Opportunity";
		} else if (this.type == "Retention Opportunities") {
			route = "/syncsalesforceactivities?client_id=" + data.id + "&user_type=Client&opp_type=Retention";
		// } else if (this.type == "Institutional Customers to Investment Clients") {
		} else if (this.type == "Bank Customers to Investment Clients") {
			route = "/syncsalesforceactivities?client_id=" + data.id + "&user_type=Prospect&opp_type=New";
		// } else if (this.type == "Institutional Customers to Deposit Clients") {
		} else if (this.type == "Bank Customers to Deposit Clients") {
			// route = "/syncsalesforceactivities?client_id=" + data.id + "&user_type=Prospect&opp_type=members";
			route = "/syncsalesforceactivities?client_id=" + data.id + "&user_type=Prospect&opp_type=New";
		} else if (this.type == "Non Customers") {
			// route = "/syncsalesforceactivities?client_id=" + data.id + "&user_type=Prospect&opp_type=non_members";
			route = "/syncsalesforceactivities?client_id=" + data.id + "&user_type=Prospect&opp_type=New";
		}

		this.openSyncActivitiesModal();

		this.commonService.getData(route).subscribe(
			(res: any) => {
				this.salesforce_sync_loader = false;
				this.commonService.showToast('success', 'Data Synced Successfully.');
				this.closeSyncActivitiesModal();
			},
			(err) => {
				this.salesforce_sync_loader = false;
				this.commonService.showToast('error', err.error);
			},
		);
	}

	min_amount_error: boolean = false;
	min_amount_error_text: any = "";
	checkAmountValidation(product, amount) {
		if (product != "" && product != null) {
			const index = this.product_list.findIndex((x) => x.id == product);

			if (index != -1) {
				const product = this.product_list[index];

				const product_min_amount = parseInt(product.min_balance_required);
				let aum: any = 0;
				if (amount != "" && amount != null) {
					aum = parseInt(amount);
				} else {
					aum = 0;
				}

				if (product_min_amount > aum) {
					this.min_amount_error = true;
					this.min_amount_error_text = "Amount Should be Greater than or Equal to " + product_min_amount;
				} else {
					this.min_amount_error = false;
					this.min_amount_error_text = "";
				}
			} else {
				this.min_amount_error = false;
				this.min_amount_error_text = "";
			}

		}
	}

	validateMaxValue(event, max_value): boolean {
		const charCode = event.which ? event.which : event.keyCode;

		// Allow only numeric input and the decimal point
		if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}

		// Get the current value of the input field
		const inputElement = event.target as HTMLInputElement;
		const currentValue = inputElement.value;

		// Check if the input value, when modified, would exceed 100
		const newValue = currentValue + String.fromCharCode(charCode);

		if (newValue !== '.' && parseFloat(newValue) > max_value) {
			return false;
		}

		return true;
	}

	addManualTask(client, index) {
		this.show_activity_view = null;
		setTimeout(() => {
			this.toggleActivityView(index);
		}, 100);

		setTimeout(() => {
			if (this.show_activity_view != null) {
				this.activitiesComponent.addIndividualManualTask();
			}
		}, 200);


	}

	@ViewChild(ActivitiesComponent) activitiesComponent!: ActivitiesComponent;

	responded_type: any = "all";
	getRespondedOpportunities() {
		this.responded_type = "active";
		this.getTableData();
	}

	// Assign Advisor
	@ViewChild('assignAdvisorModal') assignAdvisorModal: TemplateRef<any>;
	private assignAdvisorModalRef: MatDialogRef<TemplateRef<any>>;

	assign_advisor: any = "";
	assign_advisor_error: boolean = false;
	openAssignAdvisorModal() {
		if (this.selected_table_data.length > 0) {
			this.assignAdvisorModalRef = this.dialog.open(this.assignAdvisorModal, { disableClose: true });
			this.assignAdvisorModalRef.afterClosed().subscribe((result) => {
				this.closeAssignAdvisorModal();
			});
			this.move_record_error = false;
		} else {
			this.move_record_error = true;
		}
	}

	closeAssignAdvisorModal() {
		this.assignAdvisorModalRef.close();
		this.move_record_error = false;

		this.assign_advisor = "";
		this.assign_advisor_error = false;
	}

	assignAdvisor() {
		if (this.assign_advisor != "" && this.assign_advisor != null) {
			this.assign_advisor_error = false;
		} else {
			this.assign_advisor_error = true;
		}

		if (
			this.assign_advisor_error == false
		) {

			let payload: any = {
				advisor_id: this.assign_advisor,
				prospects: []
			};

			for (let index = 0; index < this.selected_table_data.length; index++) {
				payload.prospects.push(this.selected_table_data[index].id);
			}

			this.commonService.postData("/mtassignprospect/", payload).subscribe(
				(res: any) => {
					this.closeAssignAdvisorModal();
					this.getPageSummary();
					this.commonService.showToast('success', "Advisor Assigned Successfully.");
				},
				(err) => {
					this.commonService.showToast('error', err.error);
				},
			);

		}

	}


  @ViewChild('createAdvisorTeamModal') createAdvisorTeamModal: TemplateRef<any>;
  private createAdvisorTeamModalRef: MatDialogRef<TemplateRef<any>>;

  selected_advisor_team: any = {
    id: "",
    name: "",
    description: "",
    primary_advisor_id: "",
    share_percentage: "",
    team_members: []
  };
  selected_advisor_team_errors: any = {
    id: false,
    name: false,
    description: false,
    primary_advisor_id: false,
    share_percentage: false,
    team_members: false
  };
  openCreateAdvisorTeamModal() {
    if (this.selected_table_data.length > 0) {
      this.createAdvisorTeamModalRef = this.dialog.open(this.createAdvisorTeamModal, { disableClose: true });
      this.createAdvisorTeamModalRef.afterClosed().subscribe((result) => {
        this.closeCreateAdvisorTeamModal();
      });
      this.move_record_error = false;
    } else {
      this.move_record_error = true;
    }
  }

  closeCreateAdvisorTeamModal() {
    this.createAdvisorTeamModalRef.close();
    this.move_record_error = false;
    this.resetAdvisorTeamData();
  }

  resetAdvisorTeamData() {
    this.selected_advisor_team = {
      id: "",
      name: "",
      description: "",
      primary_advisor_id: "",
      share_percentage: "",
      team_members: []
    };
    this.selected_advisor_team_errors = {
      id: false,
      name: false,
      description: false,
      primary_advisor_id: false,
      share_percentage: false,
      team_members: false
    };
  }

  segregateOtherAdvisors() {
    this.selected_advisor_team.team_members = [];

    if (this.selected_advisor_team.id == 'New Team') {
      this.selected_advisor_team.team_members = JSON.parse(JSON.stringify(this.advisor_list));

      for (let index = 0; index < this.selected_advisor_team.team_members.length; index++) {
        this.selected_advisor_team.team_members[index].checked = false;
        this.selected_advisor_team.team_members[index].advisor_name = this.selected_advisor_team.team_members[index].first_name + " " + this.selected_advisor_team.team_members[index].last_name;
      }
    }

    const index = this.selected_advisor_team.team_members.findIndex(data => data.id == this.selected_advisor_team.primary_advisor_id);

    if (index > -1) {
      this.selected_advisor_team.team_members.splice(index, 1);
    }

  }

  assign_advisor_team_loader: boolean = false;
  assignAdvisorTeam() {
    if (this.selected_advisor_team.id != "" && this.selected_advisor_team.id != null) {
      this.selected_advisor_team_errors.id = false;
    } else {
      this.selected_advisor_team_errors.id = true;
    }

    if (this.selected_advisor_team.name != "" && this.selected_advisor_team.name != null) {
      this.selected_advisor_team_errors.name = false;
    } else {
      this.selected_advisor_team_errors.name = true;
    }

    // if (this.selected_advisor_team.description != "" && this.selected_advisor_team.description != null) {
    //  this.selected_advisor_team_errors.description = false;
    // } else {
    //  this.selected_advisor_team_errors.description = true;
    // }

    if (this.selected_advisor_team.primary_advisor_id != "" && this.selected_advisor_team.primary_advisor_id != null) {
      this.selected_advisor_team_errors.primary_advisor_id = false;
    } else {
      this.selected_advisor_team_errors.primary_advisor_id = true;
    }

    if (this.selected_advisor_team.share_percentage != "" && this.selected_advisor_team.share_percentage != null && (parseInt(this.selected_advisor_team.share_percentage) < 100)) {
      this.selected_advisor_team_errors.share_percentage = false;
    } else {
      this.selected_advisor_team_errors.share_percentage = true;
    }

    for (let index = 0; index < this.selected_advisor_team.team_members.length; index++) {
      if (this.selected_advisor_team.team_members[index].checked == true) {
        this.selected_advisor_team_errors.team_members = false;
        break;
      } else {
        this.selected_advisor_team_errors.team_members = true;
      }
    }

    if (
      this.selected_advisor_team_errors.id == false &&
      this.selected_advisor_team_errors.name == false &&
      // this.selected_advisor_team_errors.description == false &&
      this.selected_advisor_team_errors.primary_advisor_id == false &&
      this.selected_advisor_team_errors.share_percentage == false &&
      this.selected_advisor_team_errors.team_members == false
    ) {
      let allocated_commission: any = 0;
      allocated_commission = allocated_commission + parseInt(JSON.parse(JSON.stringify(this.selected_advisor_team.share_percentage)));
      for (let index = 0; index < this.selected_advisor_team.team_members.length; index++) {
        if (this.selected_advisor_team.team_members[index].checked == true) {
          if (this.selected_advisor_team.team_members[index].share_percentage != "" && this.selected_advisor_team.team_members[index].share_percentage != null) {
            allocated_commission = (allocated_commission + (parseInt(this.selected_advisor_team.team_members[index].share_percentage)));
          } else {
            this.selected_advisor_team_errors.team_members = true;
            break;
          }
        } else {
          this.selected_advisor_team_errors.team_members = false;
        }
      }

      if (this.selected_advisor_team_errors.team_members == false) {
        if (allocated_commission == 100) {
          this.selected_advisor_team_errors.team_members = false;
        } else {
          this.selected_advisor_team_errors.team_members = true;
        }
      }

      if (this.selected_advisor_team_errors.team_members == false) {
        let payload: any = {
          team_id: this.selected_advisor_team.id == 'New Team' ? 0 : this.selected_advisor_team.id,
          name: this.selected_advisor_team.name,
          description: this.selected_advisor_team.description,
          primary_advisor_id: this.selected_advisor_team.primary_advisor_id,
          share_percentage: this.selected_advisor_team.share_percentage,
          all_members: [],
          prospects: [],
        };

        for (let index = 0; index < this.selected_advisor_team.team_members.length; index++) {
          if (this.selected_advisor_team.team_members[index].checked == true) {
            payload.all_members.push({
              advisor_id: this.selected_advisor_team.team_members[index].id,
              share_percentage: this.selected_advisor_team.team_members[index].share_percentage,
            });
          }
        }

        for (let index = 0; index < this.selected_table_data.length; index++) {
          payload.prospects.push(this.selected_table_data[index].id);
        }

        this.assign_advisor_team_loader = true;
        this.commonService.postData("/create_team/", payload).subscribe(
          (res: any) => {
            this.closeCreateAdvisorTeamModal();
            this.commonService.showToast('success', "Advisor Team Assigned Successfully.");
            this.assign_advisor_team_loader = false;
            this.getAdvisorTeams();
            this.selected_table_data = [];
            this.is_selected = false;
          },
          (err) => {
            this.commonService.showToast('error', err.error);
            this.assign_advisor_team_loader = false;
          },
        );
      }
    }

  }



  changeCampaignAction(data){
    const payload = {
			id: data.id,
			action: data.campaign_action,
		};
		this.commonService.postData('/relationshipmanageraction/', payload).subscribe(
			(res: any) => {
				this.commonService.showToast('success', 'Campaign Action has been Updated Successfully.');
			},
			(err) => {
				this.commonService.showToast('error', err.error);
			},
		);
  }

}
